import React, { useState, useRef, useEffect, useContext } from 'react';
import { AuthContext, LoaderContext } from '../Context/ContextProvider';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import ProfileAndSettingPopUp from '../Admin/Profile/ProfileAndSettingPopUp';
import EmployerProfileAndSettingPopUp from '../Employer/Profile/ProfileAndSettingPopUp';
import { get_logout_user, toggle_seeker_subscription } from '../Services/Login/LoginApi';
import { global_search } from '../Services/Dashboard/DashboardApi';
import { ERROR_MESSAGES } from '../Componant/GlobalMessages';
import {
  get_student_profile,
  profile_Add_Update,
  Password,
  update_resume,
  deactivate_seeker,
  joblead_subscription,
  get_list_filter_signup,
} from '../Services/Student/StudentApi';
import '../StudentPanel/Profile/ProfilePopUp.css';
import { cancel_subscription, get_billing_status, create_setup_intent_for_update } from '../Services/Student/PaymentApi';
import SuccessModel from '../Componant/SuccessModel';
import ImageUploadEditModal from '../Componant/ImageUploadEditModal ';
import { FaSearch } from 'react-icons/fa';
import { FaArrowLeft } from 'react-icons/fa';
import { FaPen } from 'react-icons/fa';
import RichTextEditor from '../Componant/RichTextEditor'; // Adjust path as needed
import editIcon from '../Assets/Images/editIcon.png';
import SkillsInput from './SkillsInputs';
import ViewImagePopup from './ViewImage';
import ErrorModel from './ErrorModel';
import ConfirmationModal from './ConfirmationModal';
import './navbar.css';
import { DatePicker } from 'react-datepicker';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import 'react-datepicker/dist/react-datepicker.css';
import StripeOffcanvas from './StripeOffcanvas';
import { CustomMonthYearPicker } from './CustomDatePicker';
import { isGoogleSSOUser } from '../utils/authProvider';
import { clearEventsModuleToken } from '../utils/eventsModuleSession';
import { AUTOFILL_PAGE_PATH } from '../utils/autofillExtension';
import './Autofill/Autofill.css';
import ApplicationProfileEditor from '../StudentPanel/Profile/ApplicationProfileEditor';
import ProfileResumeUpload from '../StudentPanel/Profile/ProfileResumeUpload';
import { PROFILE_LINK_FIELDS, getApplicationError, isApiFailure, validateProfileLinks } from '../utils/applicationProfile';

const SECTION_TEXT_MAX_LENGTH = 255;
const sectionEntryTextStyle = {
  maxWidth: '100%',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};
const sectionEntryCardStyle = {
  fontSize: '14px',
  color: '#5E6278',
  fontWeight: '500',
  fontFamily: 'Inter',
  textDecoration: 'none',
};
const sectionEntryTitleStyle = {
  ...sectionEntryTextStyle,
  color: '#333',
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '1.35',
  marginBottom: '4px',
};
const sectionEntryMetaStyle = {
  ...sectionEntryTextStyle,
  color: '#5E6278',
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '1.4',
  marginBottom: '4px',
};

const NavHeader = () => {
  const location = useLocation();
  const HIDE_NAVBAR_PATHS = new Set(['/privacy-policy', '/terms-of-service']);
  if (HIDE_NAVBAR_PATHS.has(location.pathname)) {
    return null;
  }
  const [IsViewImage, setIsViewImage] = useState(false);
  const [isOpenErrorModel, setOpenErrorModel] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isCancelSubOpen, setIsCancelSubOpen] = useState(false);
  const [isConfirmDeleteEduOpen, setIsConfirmDeleteEduOpen] = useState(false);
  const [isConfirmDeleteWorkOpen, setIsConfirmDeleteWorkOpen] = useState(false);
  const [isConfirmDeleteCertificateOpen, setIsConfirmDeleteCertificateOpen] = useState(false);
  const [EDUoriginalIndex, setEDUoriginalIndex] = useState(null);
  const [workExpOriginalIndex, setWorkExpOriginalIndex] = useState(null);
  const [certificateOriginalIndex, setCertificateOriginalIndex] = useState(null);
  const [ErrorMessage, setErrorMessage] = useState('');
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState('');
  const [paymentMode, setPaymentMode] = useState('payment');
  const [selectedPlanForPayment, setSelectedPlanForPayment] = useState(null);
  const [message, setMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const dropdownRef = useRef();
  const dropdownRefMobile = useRef();
  const searchDropDownRef = useRef();
  const {
    authDetails,
    setJobs,
    isProfileUpdate,
    setIsProfileUpdate,
    setSavedCount,
    setSelectedJob,
    mapApiFilterToSelectedFilters,
    setAppliedCount,
    setJobFeedRefreshRequest,
    userRole,
    fetchJobByFilterCounts,
    searchTerm,
    setSearchTerm,
    selectedFilters,
    setSelectedFilters,
    Tab,
    setTab,
    showDropdown,
    setShowDropdown,
    setAuthDetails,
    setResumeCredit,
    studentProfile,
    setStudentProfile,
    showDropdownMobile,
    setShowDropdownMobile,
  } = useContext(AuthContext);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupTab, setPopupTab] = useState(Tab || 'profile');
  const { setStudentLoader, setLoader } = useContext(LoaderContext);
  const [jobResults, setJobResults] = useState([]);
  const [SearchResult, setSearchResult] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  // Events (@seekjobs/events-ui) is for university accounts and registered students only.
  const canAccessEvents = userRole === 'organization' || userRole === 'student_registered';
  const isEventsActive = location.pathname.toLowerCase().startsWith('/events');
  const [isSearchProcessing, setIsSearchProcessing] = useState(false);
  const [panelSearchTerm, setPanelSearchTerm] = useState('');
  const isStudentsActive = location.pathname.includes('students');
  const isStudentSearchRole = userRole === 'student_registered' || userRole === 'seeker';
  const activeSearchTerm = isStudentSearchRole ? searchTerm : panelSearchTerm;
  const [image, setImage] = useState(null);
  const [allLocations, setAllLocations] = useState([]);
  const [matchedLocations, setMatchedLocations] = useState([]);
  const [activeLocationIndex, setActiveLocationIndex] = useState(null);
  const [highlightedLocationIndex, setHighlightedLocationIndex] = useState(-1);

  const handleLocationSearch = (value, index) => {
    setActiveLocationIndex(index);
    setHighlightedLocationIndex(-1);
    if (!value || !value.trim()) {
      setMatchedLocations([]);
      return;
    }
    const searchTerm = value.toLowerCase().replace(/\s+/g, ' ').trim();
    const filtered = allLocations
      .filter(loc => {
        const label = loc.label.toLowerCase().replace(/\s+/g, ' ').trim();
        return label.includes(searchTerm);
      })
      .slice(0, 50);
    setMatchedLocations(filtered);
  };
  const isKnownLocationLabel = value => {
    const normalizedValue = (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return !!normalizedValue && allLocations.some(loc => loc.label.toLowerCase().replace(/\s+/g, ' ').trim() === normalizedValue);
  };
  const handleProfileLocationBlur = () => {
    setTimeout(() => {
      setMatchedLocations([]);
      setActiveLocationIndex(null);
    }, 200);
  };
  const handleExperienceLocationBlur = (index, value) => {
    setTimeout(() => {
      setMatchedLocations([]);
      setActiveLocationIndex(null);
      if (value && !isKnownLocationLabel(value)) {
        handleExperienceChange(index, 'location', '');
      }
    }, 200);
  };

  useEffect(() => {
    const fetchFiltersData = async () => {
      try {
        const response = await get_list_filter_signup();
        const locations = [];
        const processItem = item => {
          if (item.name && item.code) {
            locations.push({ label: `${item.name} (${item.code})`, value: item.code });
            (item.cities || []).forEach(city => {
              locations.push({ label: `${city}, ${item.code}`, value: `${city}, ${item.code}` });
            });
          }
        };
        if (response && response.us_state_city) {
          response.us_state_city.forEach(item => {
            if (item.states) item.states.forEach(state => processItem(state));
            else processItem(item);
          });
        } else if (Array.isArray(response)) {
          response.forEach(item => processItem(item));
        } else if (response && Array.isArray(response.data)) {
          response.data.forEach(item => processItem(item));
        }
        setAllLocations(locations);
      } catch (error) {
        console.error('Failed to fetch filters:', error);
      }
    };
    if (userRole === 'student_registered' || userRole === 'seeker') {
      fetchFiltersData();
    }
  }, [userRole]);

  const navigate = useNavigate();
  const now = new Date();
  const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  if (userRole === undefined || userRole === '') {
    localStorage.clear();
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        // setShowDropdownMobile(false);
        // setShowSearchDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(() => {
    const handleCloseProfileDropdown = () => {
      setShowDropdown(false);
      setShowDropdownMobile(false);
    };

    window.addEventListener('seekjobs:close-profile-dropdown', handleCloseProfileDropdown);
    return () => window.removeEventListener('seekjobs:close-profile-dropdown', handleCloseProfileDropdown);
  }, [setShowDropdown, setShowDropdownMobile]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRefMobile.current && !dropdownRefMobile.current.contains(event.target)) {
        // setShowDropdown(false);
        setShowDropdownMobile(false);
        // setShowSearchDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (searchDropDownRef.current && !searchDropDownRef.current.contains(event.target)) {
        setShowSearchDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const updateThumbnail = newThumbnail => {
    setAuthDetails(prev => {
      let updated;
      if (prev.role === 'seeker') {
        updated = {
          ...prev,
          seeker: {
            ...prev.seeker,
            thumbnail: newThumbnail,
          },
        };
      } else if (prev.role === 'student_registered') {
        updated = {
          ...prev,
          student: {
            ...prev.student,
            thumbnail: newThumbnail,
          },
        };
      } else if (prev.role === 'employer') {
        updated = {
          ...prev,
          employer: {
            ...prev.employer,
            thumbnail: newThumbnail,
            logo: newThumbnail,
          },
        };
      } else {
        return prev; // fallback
      }

      // Save to localStorage
      localStorage.setItem('login', JSON.stringify(updated));
      return updated;
    });
  };

  const updateStudentAuthProfile = mainProfile => {
    if (!mainProfile) return;

    setAuthDetails(prev => {
      if (!prev || (prev.role !== 'seeker' && prev.role !== 'student_registered')) return prev;

      const roleKey = prev.role === 'seeker' ? 'seeker' : 'student';
      const updated = {
        ...prev,
        [roleKey]: {
          ...prev[roleKey],
          ...mainProfile,
        },
      };

      if (mainProfile.is_sso !== undefined) {
        updated.is_sso = mainProfile.is_sso;
      }
      if (mainProfile.provider !== undefined && mainProfile.provider !== null) {
        updated.provider = mainProfile.provider;
      }

      localStorage.setItem('login', JSON.stringify(updated));
      return updated;
    });
  };

  const handleLogout = async () => {
    try {
      const response = await get_logout_user(); // Await server logout
      // Check if the logout was successful (based on your API's structure)

      if (!response.code?.includes('ERR')) {
        // Invalidate pending token requests and notify the embed after server logout.
        window.dispatchEvent(new Event('seekjobs:chatbot-logout'));
        clearEventsModuleToken();

        // Clear local storage and redirect only if logout is successful
        // FIX: Clear storage BEFORE redirecting, otherwise the script may stop running.
        localStorage.clear(); // This removes 'login', 'chatbotSessionId', 'subscription_tier', etc.

        // If you use cookies for session, and it's HTTPOnly, the server should clear them.
        // But if it's client-accessible (non-HTTPOnly), you can clear them here too:
        document.cookie = 'session=; Max-Age=0; path=/';

        window.location.href = '/login';
      } else {
        console.error('Logout failed:', response);
        clearEventsModuleToken();
        localStorage.clear();
        document.cookie = 'session=; Max-Age=0; path=/';
        window.location.href = '/login';
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const openPopup = (targetTab = Tab || 'profile') => {
    setPopupTab(targetTab);
    setTab(targetTab);
    setActiveTab(targetTab);
    setIsPopupOpen(true);
    if (userRole === 'student_registered' || userRole === 'seeker') {
      setTimeout(() => {
        const offcanvasElement = document.getElementById('editProfileCanvas');
        if (offcanvasElement && window.bootstrap?.Offcanvas) {
          let offcanvasInstance = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
          if (!offcanvasInstance) {
            offcanvasInstance = new window.bootstrap.Offcanvas(offcanvasElement);
          }
          offcanvasInstance.show();
        }
      }, 0);
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    if (userRole === 'student_registered' || userRole === 'seeker') {
      const offcanvasElement = document.getElementById('editProfileCanvas');
      if (offcanvasElement && window.bootstrap?.Offcanvas) {
        const offcanvasInstance = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
        if (offcanvasInstance) {
          offcanvasInstance.hide();
        }
      }
    }
  };

  // Get avatar and name based on userRole
  const avatar =
    authDetails?.organization?.thumbnail ||
    authDetails?.student?.thumbnail ||
    authDetails?.seeker?.thumbnail ||
    authDetails?.employer?.thumbnail ||
    authDetails?.employer?.logo ||
    `${process.env.PUBLIC_URL}/assets/images/avtar/Dummyimg.svg`;

  const displayName =
    authDetails?.organization?.name || authDetails?.student?.name || authDetails?.seeker?.name || authDetails?.employer?.name || 'User';

  const debounceTimeout = useRef(null); // Reference to hold timeout id
  const latestSearchRequestRef = useRef(0);

  const finishSearchRequest = requestId => {
    if (requestId === latestSearchRequestRef.current) {
      setIsSearchProcessing(false);
    }
  };

  const handlesearchChangeParam = searchParam => {
    setPanelSearchTerm(searchParam);

    // Clear the previous timeout
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const query = searchParam.trim();
    if (!query) {
      latestSearchRequestRef.current += 1;
      setIsSearchProcessing(false);
      setSearchResult([]);
      setJobResults([]);
      setShowSearchDropdown(false);
      return;
    }

    setIsSearchProcessing(true);

    // Set new timeout
    debounceTimeout.current = setTimeout(() => {
      const requestId = ++latestSearchRequestRef.current;
      if (userRole === 'organization') {
        fetchData(searchParam, requestId);
      } else {
        fetchJobs(searchParam, requestId);
      }
    }, 500); // Debounce delay (500ms)
  };
  const fetchJobs = async (searchParam, requestId) => {
    if (searchParam.trim().length === 0) {
      setJobResults([]);
      setShowSearchDropdown(false);
      finishSearchRequest(requestId);
      return;
    }

    try {
      const data = await fetchJobByFilterCounts(searchParam);
      if (data?.jobs?.fresh_jobs?.length) {
        setJobResults(data.jobs.fresh_jobs);
        setShowSearchDropdown(true);
      } else {
        setJobResults([]);
        setShowSearchDropdown(false);
      }
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setJobResults([]);
      setShowSearchDropdown(false);
    } finally {
      finishSearchRequest(requestId);
    }
  };
  const fetchData = async (searchParam, requestId) => {
    if (searchParam.trim().length === 0) {
      setSearchResult([]);
      setShowSearchDropdown(false);
      finishSearchRequest(requestId);
      return;
    }

    try {
      const data = await global_search(searchParam);

      const jobsWithType = data.jobs.map(job => ({ ...job, type: 'job' }));
      const studentsWithType = data.students.map(student => ({
        ...student,
        type: 'student',
      }));

      setShowSearchDropdown(true);
      setSearchResult([...jobsWithType, ...studentsWithType]);
    } catch (error) {
      console.error('Error fetching jobs:', error);
      setSearchResult([]);
      setShowSearchDropdown(false);
    } finally {
      finishSearchRequest(requestId);
    }
  };

  const handleSelect = async job => {
    if (userRole !== 'student_registered' && userRole !== 'seeker') return;
    if (userRole === 'organization') return;
    if (location.pathname !== '/') {
      navigate('/');
    }

    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      _query: job,
    }));
    setShowSearchDropdown(false);
  };

  const triggerSearchByRole = inputValue => {
    const query = (inputValue || '').trim();

    if (!query) {
      setIsSearchProcessing(false);
      setShowSearchDropdown(false);
      return;
    }

    if (isStudentSearchRole) {
      setSearchTerm(inputValue);
      handleSelect(query);
      return;
    }

    setPanelSearchTerm(inputValue);
    setIsSearchProcessing(true);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const requestId = ++latestSearchRequestRef.current;

    if (userRole === 'organization') {
      fetchData(query, requestId);
    } else {
      fetchJobs(query, requestId);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      triggerSearchByRole(activeSearchTerm);
    }
  };

  const searchPlaceholder = isStudentSearchRole ? 'Search job listings' : 'Search students and job listings';
  // Temporarily hide the global header search for all roles (desktop and mobile).
  const isHeaderSearchEnabled = false;
  const showHeaderSearch = isHeaderSearchEnabled && userRole !== 'employer' && location.pathname !== '/job-lead' && userRole !== 'admin';
  const searchIconClass =
    !isStudentSearchRole && isSearchProcessing
      ? 'search-bg fas fa-spinner fa-spin text-muted'
      : 'search-bg iconly-Search icli cursor-pointer';
  // --------------------------------------------------------

  const [activeTab, setActiveTab] = useState('profile');
  const [requireMessage, setRequireMessage] = useState(false);
  const [Error, setError] = useState('');
  const [isAddUpdateDone, setAddUpdateDone] = useState(false);
  const [isDeleteDone, seDeleteDone] = useState(false);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [formMode, setFormMode] = useState(null); // null | "education" | "work" | "skills"
  const [educationSelectedIndex, setEducationSelectedIndex] = useState(null);
  const [experienceSelectedIndex, setExperienceSelectedIndex] = useState(null);
  const [certificateSelectedIndex, setCertificateSelectedIndex] = useState(null);
  const [sectionDataSnapshot, setSectionDataSnapshot] = useState(null);
  const [isDiscardConfirmOpen, setIsDiscardConfirmOpen] = useState(false);

  const normalizeWorkExperienceForCompare = workExperience =>
    (workExperience || []).map(item => ({
      ...item,
      jobTitle: item?.jobTitle || '',
      companyName: item?.companyName || '',
      location: item?.location || '',
      startDate: item?.startDate || '',
      endDate: item?.endDate || '',
      currentlyWorkHere: Boolean(item?.currentlyWorkHere),
      descriptionPoints: Array.isArray(item?.descriptionPoints)
        ? item.descriptionPoints.map(point => (typeof point === 'string' ? point.trim() : '')).filter(Boolean)
        : [],
    }));

  const normalizeSectionDataForCompare = data => ({
    ...(data || {}),
    workExperience: normalizeWorkExperienceForCompare(data?.workExperience),
  });

  const checkHasChanges = () => {
    if (!sectionDataSnapshot) return false;
    return JSON.stringify(normalizeSectionDataForCompare(sectionData)) !== JSON.stringify(normalizeSectionDataForCompare(sectionDataSnapshot));
  };

  const handleDiscardAttempt = () => {
    if (checkHasChanges()) {
      setIsDiscardConfirmOpen(true);
    } else {
      handleConfirmDiscard();
    }
  };

  const handleConfirmDiscard = () => {
    if (sectionDataSnapshot) {
      setSectionData(sectionDataSnapshot);
    }
    setRequireMessage(false);
    setError('');
    setFormMode(null);
    setActiveTab('section');
    setIsDiscardConfirmOpen(false);
  };

  const [billingStatus, setBillingStatus] = useState(null);
  const [profileData, setProfileData] = useState({
    name: null,
    email: '',
    location: '',
    phone: '',
    thumbnail: '',
    resume: '',
    major: '',
    resume_name: '', // from education[0]?.major
    countryCode: '+1',
    certifications: [],
    education: [],
    personalInfo: {},
    skills: [],
    workExperience: [],
    linkedin_url: '',
    github_url: '',
    portfolio_url: '',
  });
  const savedProfileLinks = useRef({});
  const [savedResume, setSavedResume] = useState({ filename: '' });

  const [sectionData, setSectionData] = useState({
    education: [],
    workExperience: [],
    certifications: [],
    skills: [],
  });
  const [certificationForm, setCertificationForm] = useState({
    title: '',
    institution: '',
    startDate: '',
    endDate: '',
  });
  const [editingCertIndex, setEditingCertIndex] = useState(null);
  const isEducationEmpty = edu => {
    const noSchool = !edu.schoolName || edu.schoolName.trim() === '';
    const noDegree = !edu.degreeType || edu.degreeType.trim() === '';
    const noStart = !edu.startDate || edu.startDate.trim() === '';
    const noEnd = !edu.endDate || edu.endDate.trim() === '';

    // Rule: If pursuing is false and endDate missing -> invalid
    if (!edu.pursuing && noEnd) {
      return true;
    }

    // If everything important missing
    return noSchool && noDegree && noStart;
  };

  const isWorkExpericeEmpty = work => {
    const noCompany = !work.companyName || work.companyName.trim() === '';
    const noJob = !work.jobTitle || work.jobTitle.trim() === '';
    const noStart = !work.startDate || work.startDate.trim() === '';
    const noEnd = !work.endDate || work.endDate.trim() === '';

    // Rule: If not currently working, endDate is required
    if (!work.currentlyWorkHere && noEnd) {
      return true;
    }

    // If mandatory fields missing
    if (noCompany || noJob || noStart) {
      return true;
    }

    return false; // means valid entry
  };

  const isCertificateEmpty = cert => {
    return !cert.name || cert.name.trim() === '';
  };

  const getYearMonthSortKey = value => {
    if (!value || typeof value !== 'string') return null;
    const match = value.match(/^(\d{4})-(\d{2})$/);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    if (!Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) {
      return null;
    }

    return year * 12 + month;
  };

  // Chronological sort for work entries:
  // 1) explicit ongoing roles first, 2) ended roles by endDate desc, 3) fallback by startDate desc.
  const compareWorkExperienceChronologically = (a, b) => {
    const aEnd = getYearMonthSortKey(a?.endDate);
    const bEnd = getYearMonthSortKey(b?.endDate);
    const aStart = getYearMonthSortKey(a?.startDate);
    const bStart = getYearMonthSortKey(b?.startDate);

    const aOngoing = Boolean(a?.currentlyWorkHere);
    const bOngoing = Boolean(b?.currentlyWorkHere);

    if (aOngoing !== bOngoing) {
      return aOngoing ? -1 : 1;
    }

    if (!aOngoing && !bOngoing && aEnd !== null && bEnd !== null && aEnd !== bEnd) {
      return bEnd - aEnd;
    }

    const aStartSafe = aStart ?? Number.NEGATIVE_INFINITY;
    const bStartSafe = bStart ?? Number.NEGATIVE_INFINITY;
    if (aStartSafe !== bStartSafe) {
      return bStartSafe - aStartSafe;
    }

    const aTouched = Date.parse(a?.updated_at || a?.updatedAt || a?.created_at || a?.createdAt || '') || 0;
    const bTouched = Date.parse(b?.updated_at || b?.updatedAt || b?.created_at || b?.createdAt || '') || 0;
    if (aTouched !== bTouched) {
      return bTouched - aTouched;
    }

    const aIndex = Number.isFinite(a?.originalIndex) ? a.originalIndex : Number.MAX_SAFE_INTEGER;
    const bIndex = Number.isFinite(b?.originalIndex) ? b.originalIndex : Number.MAX_SAFE_INTEGER;
    if (aIndex !== bIndex) {
      return aIndex - bIndex;
    }

    return `${a?.companyName || ''} ${a?.jobTitle || ''}`.localeCompare(`${b?.companyName || ''} ${b?.jobTitle || ''}`);
  };

  // ... (countryCodes and other state variables remain unchanged)
  const countryCodes = [
    { name: 'Afghanistan', code: '+93' },
    { name: 'Albania', code: '+355' },
    { name: 'Algeria', code: '+213' },
    { name: 'American Samoa', code: '-683' },
    { name: 'Andorra', code: '+376' },
    { name: 'Angola', code: '+244' },
    { name: 'Anguilla', code: '-263' },
    { name: 'Antigua and Barbuda', code: '-267' },
    { name: 'Argentina', code: '+54' },
    { name: 'Armenia', code: '+374' },
    { name: 'Aruba', code: '+297' },
    { name: 'Australia', code: '+61' },
    { name: 'Austria', code: '+43' },
    { name: 'Azerbaijan', code: '+994' },
    { name: 'Bahamas', code: '-241' },
    { name: 'Bahrain', code: '+973' },
    { name: 'Bangladesh', code: '+880' },
    { name: 'Barbados', code: '-245' },
    { name: 'Belarus', code: '+375' },
    { name: 'Belgium', code: '+32' },
    { name: 'Belize', code: '+501' },
    { name: 'Benin', code: '+229' },
    { name: 'Bermuda', code: '-440' },
    { name: 'Bhutan', code: '+975' },
    { name: 'Bolivia', code: '+591' },
    { name: 'Bosnia and Herzegovina', code: '+387' },
    { name: 'Botswana', code: '+267' },
    { name: 'Brazil', code: '+55' },
    { name: 'British Virgin Islands', code: '-283' },
    { name: 'Brunei', code: '+673' },
    { name: 'Bulgaria', code: '+359' },
    { name: 'Burkina Faso', code: '+226' },
    { name: 'Burundi', code: '+257' },
    { name: 'Cambodia', code: '+855' },
    { name: 'Cameroon', code: '+237' },
    { name: 'Canada', code: "+1'" },
    { name: 'Cape Verde', code: '+238' },
    { name: 'Cayman Islands', code: '-344' },
    { name: 'Central African Republic', code: '+236' },
    { name: 'Chad', code: '+235' },
    { name: 'Chile', code: '+56' },
    { name: 'China', code: '+86' },
    { name: 'Colombia', code: '+57' },
    { name: 'Comoros', code: '+269' },
    { name: 'Congo', code: '+242' },
    { name: 'Cook Islands', code: '+682' },
    { name: 'Costa Rica', code: '+506' },
    { name: 'Croatia', code: '+385' },
    { name: 'Cuba', code: '+53' },
    { name: 'Curaçao', code: '+599' },
    { name: 'Cyprus', code: '+357' },
    { name: 'Czech Republic (Czechia)', code: '+420' },
    { name: 'Denmark', code: '+45' },
    { name: 'Djibouti', code: '+253' },
    { name: 'Dominica', code: '-766' },
    { name: 'Dominican Republic', code: '+1-809, +1-829, +1-849' },
    { name: 'DR Congo', code: '+243' },
    { name: 'East Timor', code: '+670' },
    { name: 'Ecuador', code: '+593' },
    { name: 'Egypt', code: '+20' },
    { name: 'El Salvador', code: '+503' },
    { name: 'Equatorial Guinea', code: '+240' },
    { name: 'Eritrea', code: '+291' },
    { name: 'Estonia', code: '+372' },
    { name: 'Eswatini', code: '+268' },
    { name: 'Ethiopia', code: '+251' },
    { name: 'Faroe Islands', code: '+298' },
    { name: 'Fiji', code: '+679' },
    { name: 'Finland', code: '+358' },
    { name: 'France', code: '+33' },
    { name: 'French Polynesia', code: '+689' },
    { name: 'Gabon', code: '+241' },
    { name: 'Gambia', code: '+220' },
    { name: 'Georgia', code: '+995' },
    { name: 'Germany', code: '+49' },
    { name: 'Ghana', code: '+233' },
    { name: 'Gibraltar', code: '+350' },
    { name: 'Greece', code: '+30' },
    { name: 'Greenland', code: '+299' },
    { name: 'Grenada', code: '-472' },
    { name: 'Guam', code: '-670' },
    { name: 'Guatemala', code: '+502' },
    { name: 'Guinea', code: '+224' },
    { name: 'Guinea-Bissau', code: '+245' },
    { name: 'Guyana', code: '+592' },
    { name: 'Haiti', code: '+509' },
    { name: 'Honduras', code: '+504' },
    { name: 'Hong Kong', code: '+852' },
    { name: 'Hungary', code: '+36' },
    { name: 'Iceland', code: '+354' },
    { name: 'India', code: '+91' },
    { name: 'Indonesia', code: '+62' },
    { name: 'Iran', code: '+98' },
    { name: 'Iraq', code: '+964' },
    { name: 'Ireland', code: '+353' },
    { name: 'Israel', code: '+972' },
    { name: 'Italy', code: '+39' },
    { name: 'Jamaica', code: '-875' },
    { name: 'Japan', code: '+81' },
    { name: 'Jordan', code: '+962' },
    { name: 'Kazakhstan', code: '+7' },
    { name: 'Kenya', code: '+254' },
    { name: 'Kiribati', code: '+686' },
    { name: 'North Korea', code: '+850' },
    { name: 'South Korea', code: '+82' },
    { name: 'Kuwait', code: '+965' },
    { name: 'Kyrgyzstan', code: '+996' },
    { name: 'Laos', code: '+856' },
    { name: 'Latvia', code: '+371' },
    { name: 'Lebanon', code: '+961' },
    { name: 'Lesotho', code: '+266' },
    { name: 'Liberia', code: '+231' },
    { name: 'Libya', code: '+218' },
    { name: 'Liechtenstein', code: '+423' },
    { name: 'Lithuania', code: '+370' },
    { name: 'Luxembourg', code: '+352' },
    { name: 'Macao', code: '+853' },
    { name: 'Madagascar', code: '+261' },
    { name: 'Malawi', code: '+265' },
    { name: 'Malaysia', code: '+60' },
    { name: 'Maldives', code: '+960' },
    { name: 'Mali', code: '+223' },
    { name: 'Malta', code: '+356' },
    { name: 'Marshall Islands', code: '+692' },
    { name: 'Mauritania', code: '+222' },
    { name: 'Mauritius', code: '+230' },
    { name: 'Mexico', code: '+52' },
    { name: 'Micronesia', code: '+691' },
    { name: 'Moldova', code: '+373' },
    { name: 'Monaco', code: '+377' },
    { name: 'Mongolia', code: '+976' },
    { name: 'Montenegro', code: '+382' },
    { name: 'Montserrat', code: '-663' },
    { name: 'Morocco', code: '+212' },
    { name: 'Mozambique', code: '+258' },
    { name: 'Myanmar', code: '+95' },
    { name: 'Namibia', code: '+264' },
    { name: 'Nauru', code: '+674' },
    { name: 'Nepal', code: '+977' },
    { name: 'Netherlands', code: '+31' },
    { name: 'New Caledonia', code: '+687' },
    { name: 'New Zealand', code: '+64' },
    { name: 'Nicaragua', code: '+505' },
    { name: 'Niger', code: '+227' },
    { name: 'Nigeria', code: '+234' },
    { name: 'Niue', code: '+683' },
    { name: 'North Macedonia', code: '+389' },
    { name: 'Norway', code: '+47' },
    { name: 'Oman', code: '+968' },
    { name: 'Pakistan', code: '+92' },
    { name: 'Palau', code: '+680' },
    { name: 'Palestine', code: '+970' },
    { name: 'Panama', code: '+507' },
    { name: 'Papua New Guinea', code: '+675' },
    { name: 'Paraguay', code: '+595' },
    { name: 'Peru', code: '+51' },
    { name: 'Philippines', code: '+63' },
    { name: 'Poland', code: '+48' },
    { name: 'Portugal', code: '+351' },
    { name: 'Puerto Rico', code: '+1-787, +1-939' },
    { name: 'Qatar', code: '+974' },
    { name: 'Romania', code: '+40' },
    { name: 'Russia', code: '+7' },
    { name: 'Rwanda', code: '+250' },
    { name: 'Saint Kitts and Nevis', code: '-868' },
    { name: 'Saint Lucia', code: '-757' },
    { name: 'Saint Vincent and the Grenadines', code: '-783' },
    { name: 'Samoa', code: '+685' },
    { name: 'San Marino', code: '+378' },
    { name: 'Sao Tome and Principe', code: '+239' },
    { name: 'Saudi Arabia', code: '+966' },
    { name: 'Senegal', code: '+221' },
    { name: 'Serbia', code: '+381' },
    { name: 'Seychelles', code: '+248' },
    { name: 'Sierra Leone', code: '+232' },
    { name: 'Singapore', code: '+65' },
    { name: 'Sint Maarten', code: '-720' },
    { name: 'Slovakia', code: '+421' },
    { name: 'Slovenia', code: '+386' },
    { name: 'Solomon Islands', code: '+677' },
    { name: 'Somalia', code: '+252' },
    { name: 'South Africa', code: '+27' },
    { name: 'South Sudan', code: '+211' },
    { name: 'Spain', code: '+34' },
    { name: 'Sri Lanka', code: '+94' },
    { name: 'Sudan', code: '+249' },
    { name: 'Suriname', code: '+597' },
    { name: 'Sweden', code: '+46' },
    { name: 'Switzerland', code: '+41' },
    { name: 'Syria', code: '+963' },
    { name: 'Taiwan', code: '+886' },
    { name: 'Tajikistan', code: '+992' },
    { name: 'Tanzania', code: '+255' },
    { name: 'Thailand', code: '+66' },
    { name: 'Togo', code: '+228' },
    { name: 'Tonga', code: '+676' },
    { name: 'Trinidad and Tobago', code: '-867' },
    { name: 'Tunisia', code: '+216' },
    { name: 'Turkey', code: '+90' },
    { name: 'Turkmenistan', code: '+993' },
    { name: 'Tuvalu', code: '+688' },
    { name: 'Uganda', code: '+256' },
    { name: 'Ukraine', code: '+380' },
    { name: 'United Arab Emirates', code: '+971' },
    { name: 'United Kingdom', code: '+44' },
    { name: 'United States', code: '+1' },
    { name: 'Uruguay', code: '+598' },
    { name: 'Uzbekistan', code: '+998' },
    { name: 'Vanuatu', code: '+678' },
    { name: 'Vatican City', code: '+379' },
    { name: 'Venezuela', code: '+58' },
    { name: 'Vietnam', code: '+84' },
    { name: 'Yemen', code: '+967' },
    { name: 'Zambia', code: '+260' },
    { name: 'Zimbabwe', code: '+263' },
  ];

  const [settingsData, setSettingsData] = useState({
    password: '',
    newPassword: '',
    retypePassword: '',
  });
  const [passwordStrength, setPasswordStrength] = useState('');

  const [showPassword, setShowPassword] = useState({
    password: false,
    newPassword: false,
    retypePassword: false,
  });

  const [errors, setErrors] = useState({});
  const [workExperienceList, setExperienceList] = useState([
    {
      jobTitle: '',
      companyName: '',
      location: '',
      startDate: '',
      endDate: '',
      currentlyWorkHere: false,
      descriptionPoints: [],
    },
  ]);

  useEffect(() => {
    if (
      profileData.education.length ||
      profileData.workExperience.length ||
      profileData.skills.length ||
      profileData.certifications.length // 👈 include this
    ) {
      setSectionData({
        education: profileData.education || [],
        workExperience: profileData.workExperience || [],
        skills: profileData.skills || [],
        certifications: profileData.certifications || [], // 👈 ensure this
      });
    }
  }, [profileData.education, profileData.workExperience, profileData.skills, profileData.certifications]);

  useEffect(() => {
    if (Tab) {
      setActiveTab(Tab);
    }
  }, [Tab]);

  useEffect(() => {
    // This effect listens for the Bootstrap offcanvas 'show' event.
    // This is a more reliable way to trigger data fetching than relying on component state.
    const offcanvasElement = document.getElementById('editProfileCanvas');

    const handleOffcanvasShow = () => {
      // Conditionally fetch billing status only for seekers.
      if (userRole === 'seeker') {
        // Fetch both profile and billing status in parallel for efficiency.
        Promise.all([get_student_profile_data(), fetchBillingStatus()]).catch(error => {
          const apiError =
            error?.response?.data?.message || error?.response?.data?.error || 'Failed to load profile data. Please try again.';
          setErrorMessage(apiError);
          setOpenErrorModel(true);
          console.error('Error fetching data for offcanvas:', error); // Keep console log for debugging
        });
      } else {
        // For other roles (like student_registered), only fetch profile data.
        get_student_profile_data().catch(error => {
          const apiError =
            error?.response?.data?.message || error?.response?.data?.error || 'Failed to load profile data. Please try again.';
          setErrorMessage(apiError);
          setOpenErrorModel(true);
          console.error('Error fetching student profile for offcanvas:', error); // Keep console log for debugging
        });
      }
    };

    const handleOffcanvasHidden = () => {
      setIsPopupOpen(false);

      // Cleanup unsaved new entries
      setSectionData(prev => {
        const cleanedEducation = prev.education.filter(edu => !edu.isNew);
        const cleanedWork = prev.workExperience.filter(work => !work.isNew);
        const cleanedCert = prev.certifications.filter(cert => !cert.isNew);
        return {
          ...prev,
          education: cleanedEducation,
          workExperience: cleanedWork,
          certifications: cleanedCert,
        };
      });

      setFormMode(null);
      setActiveTab('profile'); // Reset to default tab
      setRequireMessage(false);
      setError('');

      // Ensure all Bootstrap-related artifacts are cleaned up
      document.querySelectorAll('.offcanvas-backdrop').forEach(el => el.remove());
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '0';
    };

    if (offcanvasElement) {
      offcanvasElement.addEventListener('show.bs.offcanvas', handleOffcanvasShow);
      offcanvasElement.addEventListener('hidden.bs.offcanvas', handleOffcanvasHidden);

      // Cleanup function to remove the event listeners when the component unmounts.
      return () => {
        offcanvasElement.removeEventListener('show.bs.offcanvas', handleOffcanvasShow);
        offcanvasElement.removeEventListener('hidden.bs.offcanvas', handleOffcanvasHidden);
      };
    }
  }, [userRole]); // Rerun if the user role changes.

  useEffect(() => {
    if (isAddUpdateDone) {
      setIsProfileUpdate(true);
      get_student_profile_data();
      setAddUpdateDone(false);
    }
  }, [isAddUpdateDone]);
  // Remove an education section
  const handleRemoveEducation = async index => {
    const updatedList = [...(sectionData.education || [])];
    updatedList.splice(index, 1);

    const newSectionData = {
      ...sectionData,
      education: updatedList,
    };

    setSectionData(newSectionData);
    setIsConfirmDeleteEduOpen(false);
    await handleSave(true, newSectionData);
  };

  // Remove an education section
  const handleRemoveWorkExperience = async index => {
    const updatedList = [...(sectionData.workExperience || [])];
    updatedList.splice(index, 1);

    const newSectionData = {
      ...sectionData,
      workExperience: updatedList,
    };

    setSectionData(newSectionData);
    setIsConfirmDeleteWorkOpen(false);
    await handleSave(true, newSectionData);
  };
  // Handle input changes
  const handleChange = (index, field, value) => {
    const updatedList = [...sectionData?.education];

    if (field === 'pursuing') {
      updatedList[index][field] = value;
      if (value === true) {
        // If pursuing is selected, clear end date.
        updatedList[index].endDate = '';
      }
    } else if (field === 'endDate') {
      updatedList[index][field] = value;
      if (value) {
        // If end date is selected, this is no longer a pursuing record.
        updatedList[index].pursuing = false;
      }
    } else {
      updatedList[index][field] = value;
    }

    setSectionData(prev => ({
      ...prev,
      education: updatedList,
    }));
  };
  const handleExperienceChange = (index, field, value) => {
    const updatedList = [...sectionData.workExperience];

    if (field === 'currentlyWorkHere') {
      updatedList[index] = {
        ...updatedList[index],
        [field]: value,
        endDate: value ? '' : updatedList[index].endDate, // ✅ clear endDate if checked
      };
    } else {
      updatedList[index] = {
        ...updatedList[index],
        [field]: value,
      };
    }

    setSectionData(prev => ({
      ...prev,
      workExperience: updatedList,
    }));
  };

  const handleCertificationsChange = (index, field, value) => {
    const updatedList = [...sectionData?.certifications];
    updatedList[index][field] = value;
    setSectionData(prev => ({
      ...prev,
      certifications: updatedList,
    }));
  };
  const handleAddEducation = () => {
    setSectionDataSnapshot(JSON.parse(JSON.stringify(sectionData)));
    setSectionData(prev => {
      const newEducation = [
        ...prev.education,
        {
          schoolName: '',
          degreeType: '',
          gpa: '',
          major: '',
          startDate: '',
          endDate: '',
          pursuing: false,
          isNew: true,
        },
      ];

      // ✅ Use the last index (newly added entry’s original index)
      const newIndex = newEducation.length - 1;

      setEducationSelectedIndex(newIndex); // point form to the new entry

      return {
        ...prev,
        education: newEducation,
      };
    });

    setFormMode('education');
    setActiveTab('form');
  };

  const handleEditEducation = (value, index) => {
    setSectionDataSnapshot(JSON.parse(JSON.stringify(sectionData)));
    setRequireMessage(false);
    setEducationSelectedIndex(index);
    const today = new Date();
    const end = new Date(value?.endDate + '-01'); // Add day to make it parsable (e.g., "2023-12" → "2023-12-01")

    const isPursuing = end >= new Date(today.getFullYear(), today.getMonth(), 1); // True if endDate is this month or in the future
    setEducationSelectedIndex(index);
    setFormMode('education'); // 👈 triggers form view
    setActiveTab('form');
  };

  const handleAddWorkExperience = () => {
    setSectionDataSnapshot(JSON.parse(JSON.stringify(sectionData)));
    setRequireMessage(false);
    setSectionData(prev => ({
      ...prev,
      workExperience: [
        ...prev.workExperience,
        {
          jobTitle: '',
          companyName: '',
          location: '',
          startDate: '',
          endDate: '',
          currentlyWorkHere: false,
          descriptionPoints: [],
          isNew: true,
        },
      ],
    }));
    setExperienceSelectedIndex(sectionData?.workExperience?.length);
    setExperienceList([
      {
        jobTitle: '',
        companyName: '',
        location: '',
        startDate: '',
        endDate: '',
        currentlyWorkHere: false,
        descriptionPoints: [],
      },
    ]);
    setFormMode('workExperiance');
    setActiveTab('form');
  };
  const handleEditExperience = (value, index) => {
    setSectionDataSnapshot(JSON.parse(JSON.stringify(sectionData)));
    setExperienceSelectedIndex(index);
    const today = new Date();
    const end = new Date(value?.endDate + '-01'); // Add day to make it parsable (e.g., "2023-12" → "2023-12-01")

    const isPursuing = end >= new Date(today.getFullYear(), today.getMonth(), 1); // True if endDate is this month or in the future

    setFormMode('workExperiance'); // 👈 triggers form view
    setActiveTab('form');
  };

  const handleTabClick = tab => {
    if (activeTab === 'profile' && tab !== 'profile' && tab !== 'application' && !profileData.location?.trim()) {
      setRequireMessage(true);
      setTimeout(() => {
        const locationInput = document.querySelector('#editProfileCanvas input[name="location"]');
        locationInput?.focus();
      }, 0);
      return;
    }

    setError('');
    setActiveTab(tab);
    setRequireMessage(false);
  };

  const getPrimaryCountryCode = code => {
    const firstCode = String(code || '')
      .split(',')[0]
      .trim();
    const digitsOnly = firstCode.replace(/[^\d]/g, '');
    return digitsOnly ? `+${digitsOnly}` : '+1';
  };

  const formatPhoneForInput = digits => {
    if (!digits) return '';
    if (digits.length === 10) {
      return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    return digits;
  };

  const parsePhoneWithCountry = (rawPhone, fallbackCountryCode = '+1') => {
    const raw = String(rawPhone || '').trim();
    const allDigits = raw.replace(/\D/g, '');

    if (!allDigits) {
      return { countryCode: fallbackCountryCode, phone: '' };
    }

    const countryCodeOptions = countryCodes
      .map(country => ({
        optionValue: country.code,
        primaryCode: getPrimaryCountryCode(country.code),
      }))
      .filter(item => item.primaryCode)
      .sort((a, b) => b.primaryCode.length - a.primaryCode.length);

    const normalizedRaw = raw.startsWith('+') ? `+${allDigits}` : allDigits;

    if (raw.startsWith('+')) {
      const matched = countryCodeOptions.find(item => normalizedRaw.startsWith(item.primaryCode));
      if (matched) {
        const prefixDigits = matched.primaryCode.replace(/\D/g, '');
        const localDigits = allDigits.startsWith(prefixDigits) ? allDigits.slice(prefixDigits.length) : allDigits;
        return {
          countryCode: matched.optionValue,
          phone: formatPhoneForInput(localDigits),
        };
      }
    }

    return {
      countryCode: fallbackCountryCode,
      phone: formatPhoneForInput(allDigits),
    };
  };

  const normalizePhoneAgainstCountry = (phoneValue, countryCodeValue) => {
    const raw = String(phoneValue || '').trim();
    const selectedCode = getPrimaryCountryCode(countryCodeValue);
    const selectedCodeDigits = selectedCode.replace(/\D/g, '');

    let effectiveCountryCode = selectedCode;
    let localDigits = raw.replace(/\D/g, '');

    // If user typed country code in the right-side input (e.g. +91...), parse it and extract local part.
    if (raw.startsWith('+')) {
      const parsed = parsePhoneWithCountry(raw, selectedCode);
      effectiveCountryCode = getPrimaryCountryCode(parsed.countryCode || selectedCode);
      localDigits = String(parsed.phone || '').replace(/\D/g, '');
    } else if (selectedCodeDigits && localDigits.startsWith(selectedCodeDigits) && localDigits.length - selectedCodeDigits.length >= 7) {
      // Handle case where user types country code without plus in right-side field.
      localDigits = localDigits.slice(selectedCodeDigits.length);
    }

    return {
      effectiveCountryCode,
      localDigits,
    };
  };

  const normalizeLocalDigitsForCountry = (localDigits, countryCodeValue) => {
    const countryCode = getPrimaryCountryCode(countryCodeValue);
    let digits = String(localDigits || '').replace(/\D/g, '');

    // India numbers are often entered with a trunk prefix `0`.
    if (countryCode === '+91' && digits.length === 11 && digits.startsWith('0')) {
      digits = digits.slice(1);
    }

    return digits;
  };

  const isValidPhoneByCountry = (phoneValue, countryCodeValue) => {
    const normalized = normalizePhoneAgainstCountry(phoneValue, countryCodeValue);
    const phoneDigits = normalizeLocalDigitsForCountry(normalized.localDigits, normalized.effectiveCountryCode);
    const codeDigits = normalized.effectiveCountryCode.replace(/\D/g, '');

    if (!phoneDigits) {
      return false;
    }

    if (normalized.effectiveCountryCode === '+91') {
      return /^[6-9]\d{9}$/.test(phoneDigits);
    }

    if (phoneDigits.length < 7 || phoneDigits.length > 12) {
      return false;
    }

    // E.164 max length
    return phoneDigits.length + codeDigits.length <= 15;
  };

  const handleProfileChange = e => {
    const { name, value } = e.target;
    if (PROFILE_LINK_FIELDS.some(field => field.name === name)) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }

    // Handle phone number formatting
    if (name === 'phone') {
      const normalized = normalizePhoneAgainstCountry(value, profileData.countryCode);
      const normalizedLocalDigits = normalizeLocalDigitsForCountry(normalized.localDigits, normalized.effectiveCountryCode);
      const formattedValue = formatPhoneForInput(normalizedLocalDigits);

      setProfileData(prev => ({
        ...prev,
        countryCode: normalized.effectiveCountryCode || prev.countryCode,
        phone: formattedValue,
      }));
    } else if (name === 'countryCode') {
      const normalized = normalizePhoneAgainstCountry(profileData.phone, value);
      const normalizedLocalDigits = normalizeLocalDigitsForCountry(normalized.localDigits, value);

      setProfileData(prev => ({
        ...prev,
        countryCode: value,
        phone: formatPhoneForInput(normalizedLocalDigits),
      }));
    } else if (name === 'location') {
      // Validate Full Name to allow only letters and spaces (no numbers or dots)
      const filteredValue = value.replace(/[^a-zA-Z, ]/g, '');

      setProfileData(prev => ({
        ...prev,
        [name]: filteredValue,
      }));
    } else if (name === 'fullName') {
      const nameRegex = /^[A-Za-z\s]*$/;
      if (nameRegex.test(value) || value === '') {
        setProfileData(prev => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      setProfileData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const toggleVisibility = field => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSettingsChange = e => {
    const { name, value } = e.target;

    setSettingsData(prev => ({
      ...prev,
      [name]: value,
    }));
    setError('');
    // Clear the error for this field if it's now valid
    setErrors(prevErrors => {
      const updatedErrors = { ...prevErrors };

      // Remove "required" error if input is not empty
      if (value.trim() !== '') {
        delete updatedErrors[name];
      }

      // Special case: validate `newPassword` live
      if (name === 'newPassword') {
        if (value.length >= 8 && /[A-Z]/.test(value) && /[a-z]/.test(value) && /\W/.test(value)) {
          delete updatedErrors[name];
        }
      }

      return updatedErrors;
    });

    // Optional: Update password strength live
    if (name === 'newPassword') {
      setPasswordStrength(getPasswordStrength(value));
    }
  };

  const handleUpdatePassword = async () => {
    const { password, newPassword, retypePassword } = settingsData;
    const newErrors = {};

    // Validation: required fields
    if (!password) newErrors.password = 'Current password is required.';
    if (!newPassword) newErrors.newPassword = 'New password is required.';
    if (!retypePassword) newErrors.retypePassword = 'Please retype new password.';

    // Validation: length
    if (newPassword && newPassword.length < 8) {
      newErrors.newPassword = 'Password must be at least 8 characters.';
    }

    // Validation: must differ from current password
    if (newPassword && password && newPassword === password) {
      newErrors.newPassword = 'New password must be different from current.';
    }

    // Validation: password match
    if (newPassword && retypePassword && newPassword !== retypePassword) {
      newErrors.retypePassword = 'Passwords do not match.';
    }

    // Specific password rule validations (only if no previous newPassword error)
    if (newPassword && !newErrors.newPassword) {
      if (!/[A-Z]/.test(newPassword)) {
        newErrors.newPassword = 'Password must contain at least one uppercase letter.';
      } else if (!/[a-z]/.test(newPassword)) {
        newErrors.newPassword = 'Password must contain at least one lowercase letter.';
      } else if (!/\W/.test(newPassword)) {
        newErrors.newPassword = 'Password must contain at least one special character.';
      }
    }

    setErrors(newErrors);

    // Submit if no errors
    if (Object.keys(newErrors).length === 0) {
      setLoader(true);
      const data = await Password({
        old_password: settingsData.password,
        new_password: settingsData.newPassword,
      });

      setLoader(false);

      if (!data?.code?.includes('ERR')) {
        setIsSuccessOpen(true);

        // Optionally reset form
        setSettingsData({
          password: '',
          newPassword: '',
          retypePassword: '',
        });

        setPasswordStrength(''); // reset bar
      } else {
        setError(data?.response?.data?.message || 'Something went wrong. Please try again.');
      }
    }
  };
  const getPasswordStrength = value => {
    let strength = 0;
    if (value.length >= 8) strength++;
    if (/[A-Z]/.test(value)) strength++;
    if (/[a-z]/.test(value)) strength++;
    if (/\W/.test(value)) strength++;

    if (strength <= 2) return 'Weak';
    if (strength === 3) return 'Fair';
    if (strength === 4) return 'Strong';
  };

  const getStrengthColor = strength => {
    switch (strength) {
      case 'Weak':
        return '#dc3545'; // red
      case 'Fair':
        return '#ffc107'; // yellow/orange
      case 'Strong':
        return '#28a745'; // green
      default:
        return '#6c757d';
    }
  };

  const getStrengthWidth = strength => {
    switch (strength) {
      case 'Weak':
        return '33%';
      case 'Fair':
        return '66%';
      case 'Strong':
        return '100%';
      default:
        return '0%';
    }
  };

  const get_student_profile_data = async () => {
    try {
      const data = await get_student_profile();

      if (data && data.profile) {
        const { resume_file: resumeFile, ...mainProfile } = data.profile;
        setSavedResume({ filename: mainProfile.resume_name || resumeFile?.filename || '' });
        const nestedData = mainProfile.profile_data || {};
        savedProfileLinks.current = Object.fromEntries(PROFILE_LINK_FIELDS.map(({ name }) => [name, mainProfile[name] || '']));
        setStudentProfile(mainProfile);
        // The backend sends 'resume_credits' which can be a number or 'Unlimited'.
        // We will handle both cases.
        const credits = mainProfile.resume_credits;
        if (credits !== undefined) {
          setResumeCredit(credits);
        }
        setJobAlertsEnabled(mainProfile.is_subscribed || false);
        const phoneFromApi = mainProfile.phone || '';
        const parsedPhone = parsePhoneWithCountry(phoneFromApi, '+1');

        setProfileData({
          fullName: mainProfile.name || '',
          email: mainProfile.email || '',
          location: mainProfile.location || '',
          phone: parsedPhone.phone || '',
          thumbnail: mainProfile.thumbnail || '',
          resume: '',
          countryCode: parsedPhone.countryCode || '+1',
          resume_name: mainProfile.resume_name,
          major: nestedData.education?.[0]?.major || '',

          certifications: nestedData.certifications || [],
          education: nestedData.education || [],
          personalInfo: nestedData.personalInfo || {},
          skills: nestedData.skills || [],
          workExperience: nestedData.workExperience || [],
          ...savedProfileLinks.current,
        });

        updateStudentAuthProfile(mainProfile);
      }
    } catch (error) {
      console.error('Error fetching student profile:', error);
    }
  };
  const allowedTypes = [
    'application/pdf', // PDF
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'text/plain', // .txt
  ]; // .txt
  const maxFileSize = 15 * 1024 * 1024; // 15 MB
  const handleSave = async (isDeleteAction = false, dataToSave = sectionData) => {
    if (typeof isDeleteAction === 'object' && typeof isDeleteAction?.preventDefault === 'function') {
      isDeleteAction.preventDefault();
      isDeleteAction = false;
    }

    const linkErrors = validateProfileLinks(profileData);
    setErrors(linkErrors);
    if (Object.keys(linkErrors).length) {
      setActiveTab('profile');
      setErrorMessage('Please correct the highlighted profile links.');
      setOpenErrorModel(true);
      return;
    }

    const missingProfileFields = [];
    if (!profileData.location || !profileData.location.trim()) {
      missingProfileFields.push('Location');
    }

    if (missingProfileFields.length > 0) {
      setRequireMessage(true);
      setErrorMessage('The following profile fields are missing: ' + missingProfileFields.join(', ') + '.');
      setOpenErrorModel(true);
      return;
    }

    if (profileData.phone && !isValidPhoneByCountry(profileData.phone, profileData.countryCode)) {
      setRequireMessage(true);
      setErrorMessage('Enter a valid phone number.');
      setOpenErrorModel(true);
      return;
    }

    if (profileData.resume && (!allowedTypes.includes(profileData.resume.type) || profileData.resume.size > maxFileSize)) {
      setErrorMessage('Accepted file types: .docx, .pdf, .txt\nMaximum file size: 15 MB');
      setOpenErrorModel(true);
      return;
    }

    const isMeaningfulValue = val => {
      if (typeof val === 'string') return val.trim() !== '';
      if (Array.isArray(val)) return val.some(v => isMeaningfulValue(v));
      return !(val === null || val === undefined || val === false);
    };

    const isObjectEmpty = (obj, sectionType = null) => {
      if (!obj) return true;

      // Metadata and internal flags to ignore when checking if the object has ACTUAL user content
      const ignoreFields = [
        'isNew',
        'originalIndex',
        'id',
        '_id',
        'createdAt',
        'updatedAt',
        'created_at',
        'updated_at',
        'currentlyWorkHere',
        'pursuing',
        'descriptionPoints',
      ];

      const rest = {};
      Object.keys(obj).forEach(key => {
        if (!ignoreFields.includes(key)) {
          rest[key] = obj[key];
        }
      });

      // Special check for descriptionPoints - they are meaningful if at least one is not empty
      if (Array.isArray(obj.descriptionPoints) && obj.descriptionPoints.some(p => p && p.trim() !== '')) {
        return false;
      }

      // Object is empty if ALL remaining properties are NOT meaningful
      return !Object.values(rest).some(val => isMeaningfulValue(val));
    };

    const failValidation = message => {
      setRequireMessage(true);
      setError(message);
      setErrorMessage(message);
      setOpenErrorModel(true);
      return false;
    };

    const getIndexesToValidate = (arr = [], selectedIndex = null) => {
      if (selectedIndex === null || selectedIndex === undefined) {
        return arr.map((_, idx) => idx);
      }
      if (selectedIndex >= 0 && selectedIndex < arr.length) {
        return [selectedIndex];
      }
      return [];
    };

    const fieldText = value => (value ?? '').toString().trim();

    const validateEducation = (arr = [], selectedIndex = null) => {
      const indexes = getIndexesToValidate(arr, selectedIndex);
      for (const i of indexes) {
        const item = arr[i];
        if (!item) continue;

        const isEditingThisRow = selectedIndex !== null && i === selectedIndex;
        const shouldValidate = isEditingThisRow || item?.isNew || !isObjectEmpty(item);

        if (!shouldValidate) continue;

        const missingFields = [];
        // ✅ Prioritize schoolName/degreeType but don't fall back if they are empty strings (cleared by user)
        const school = fieldText(item.schoolName !== undefined ? item.schoolName : item.school);
        const degree = fieldText(item.degreeType !== undefined ? item.degreeType : item.degree);
        const start = fieldText(item.startDate);
        const end = fieldText(item.endDate);

        if (!school) missingFields.push('School / University');
        if (!degree) missingFields.push('Degree');

        if (missingFields.length > 0) {
          const verb = missingFields.length > 1 ? ' are ' : ' is ';
          return failValidation(missingFields.join(', ') + verb + 'required.');
        }

        const now = new Date();
        if (start) {
          const startDate = new Date(start);
          if (startDate > now) {
            return failValidation('Start date cannot be in the future.');
          }

          if (!item.pursuing && end) {
            const endDate = new Date(end);
            if (startDate > endDate) {
              return failValidation('Start date cannot be after end date.');
            }
          }
        }
      }

      return true;
    };

    const validateWorkExperience = (arr = [], selectedIndex = null) => {
      const indexes = getIndexesToValidate(arr, selectedIndex);
      for (const i of indexes) {
        const item = arr[i];
        if (!item) continue;

        const isEditingThisRow = selectedIndex !== null && i === selectedIndex;
        const shouldValidate = isEditingThisRow || item?.isNew || !isObjectEmpty(item);

        if (!shouldValidate) continue;

        const missingFields = [];
        const jobTitle = fieldText(item.jobTitle !== undefined ? item.jobTitle : item.title);
        const companyName = fieldText(item.companyName !== undefined ? item.companyName : item.company);
        const start = fieldText(item.startDate);
        const end = fieldText(item.endDate);

        if (!jobTitle) missingFields.push('Job Title');
        if (!companyName) missingFields.push('Company');

        if (missingFields.length > 0) {
          const verb = missingFields.length > 1 ? ' are ' : ' is ';
          return failValidation(missingFields.join(', ') + verb + 'required.');
        }

        const now = new Date();
        if (start) {
          const startDate = new Date(start);
          if (startDate > now) {
            return failValidation('Start date cannot be in the future.');
          }

          if (!item.currentlyWorkHere && end) {
            const endDate = new Date(end);
            if (startDate > endDate) {
              return failValidation('Start date cannot be after end date.');
            }
          }
        }
      }

      return true;
    };

    const validateCertifications = (arr = [], selectedIndex = null) => {
      const indexes = getIndexesToValidate(arr, selectedIndex);
      for (const i of indexes) {
        const item = arr[i];
        if (!item) continue;

        const isEditingThisRow = selectedIndex !== null && i === selectedIndex;
        const shouldValidate = isEditingThisRow || item?.isNew || !isObjectEmpty(item);

        if (!shouldValidate) continue;

        const missingFields = [];
        const name = fieldText(item.name);

        if (!name) missingFields.push('Certification Name');

        if (missingFields.length > 0) {
          const verb = missingFields.length > 1 ? ' are ' : ' is ';
          return failValidation(missingFields.join(', ') + verb + 'required.');
        }

        const now = new Date();
        if (item.issueDate) {
          const issueDate = new Date(item.issueDate);
          if (issueDate > now) {
            return failValidation('Issue date cannot be in the future.');
          }

          if (item.expiryDate) {
            const expiryDate = new Date(item.expiryDate);
            if (issueDate > expiryDate) {
              return failValidation('Issue date cannot be after expiration date.');
            }
          }
        }
      }

      return true;
    };

    if (!isDeleteAction) {
      // ✅ ALWAYS validate ALL sections before saving to prevent any bypass.
      const eduIdx = activeTab === 'form' && formMode === 'education' ? educationSelectedIndex : null;
      if (!validateEducation(dataToSave.education, eduIdx)) return;

      const workIdx = activeTab === 'form' && formMode === 'workExperiance' ? experienceSelectedIndex : null;
      if (!validateWorkExperience(dataToSave.workExperience, workIdx)) return;

      const certIdx = activeTab === 'form' && formMode === 'certification' ? certificateSelectedIndex : null;
      if (!validateCertifications(dataToSave.certifications, certIdx)) return;
    }

    setLoader(true);

    const { email, fullName, profile_data, linkedin_url, github_url, portfolio_url, ...restProfile } = profileData;
    const changedLinks = {};
    PROFILE_LINK_FIELDS.forEach(({ name }) => {
      const value = (profileData[name] || '').trim();
      if (value !== (savedProfileLinks.current[name] || '')) changedLinks[name] = value || null;
    });

    const cleanSection = arr => arr.filter(item => !isObjectEmpty(item)).map(({ isNew, originalIndex, ...rest }) => rest);
    const normalizeEducation = arr =>
      cleanSection(arr).map(item => ({
        ...item,
        endDate: item.pursuing ? null : item.endDate || null,
      }));
    const normalizeWorkExperience = arr =>
      cleanSection(arr).map(item => ({
        ...item,
        endDate: item.currentlyWorkHere ? null : item.endDate || null,
        descriptionPoints: Array.isArray(item.descriptionPoints)
          ? item.descriptionPoints.map(point => (typeof point === 'string' ? point.trim() : point)).filter(Boolean)
          : [],
      }));

    const payload = {
      ...restProfile,
      ...changedLinks,
      profile_data: {
        ...restProfile.personalInfo,
        education: normalizeEducation(dataToSave.education || []).sort((a, b) => new Date(b.startDate) - new Date(a.startDate)),
        workExperience: normalizeWorkExperience(dataToSave.workExperience || []).sort(compareWorkExperienceChronologically),
        skills: (dataToSave.skills || []).filter(s => s && s.trim() !== ''),
        certifications: cleanSection(dataToSave.certifications || []),
      },
    };

    const data = await profile_Add_Update({ profile: payload });

    if (isApiFailure(data)) {
      const apiError = getApplicationError(data, 'Unable to save your profile. Please retry.');
      setErrors(apiError.details);
      setErrorMessage(apiError.message);
      setOpenErrorModel(true);
      setLoader(false);
      return;
    }
    const savedProfile = data.student || data.seeker || data.profile;
    const savedLinks = Object.fromEntries(PROFILE_LINK_FIELDS.map(({ name }) => [name, savedProfile && Object.prototype.hasOwnProperty.call(savedProfile, name) ? savedProfile[name] || '' : profileData[name] || '']));
    savedProfileLinks.current = savedLinks;
    setProfileData(prev => ({ ...prev, ...savedLinks }));
    if (savedProfile) updateStudentAuthProfile(savedProfile);

    if (profileData.resume) {
      try {
        const formData = new FormData();
        formData.append('resume', profileData.resume);
        const response = await update_resume(formData);
        if (response.code && response.code.includes('ERR')) {
          setErrorMessage(response?.response?.data?.error || response?.response?.data?.message);
          setOpenErrorModel(true);
          setLoader(false);
          return;
        }
        setJobFeedRefreshRequest(prev => prev + 1);
      } catch (resumeError) {
        console.error('Error while uploading resume:', resumeError);
        setError('Resume upload failed. Please try again.');
        setLoader(false);
        return;
      }
    }

    if (data?.status !== 500 && data?.status !== 400) {
      setLoader(false);
      setIsSuccessOpen(true);
      setActiveTab(isDeleteAction || activeTab === 'form' ? 'section' : activeTab);
    } else {
      setLoader(false);
      setError(data.response?.data?.error || 'An error occurred');
    }
  };
  const handleFileChange = file => {
    if (file) {
      setProfileData(prev => ({
        ...prev,
        resume: file,
        resume_name: file.name, // Includes extension (e.g., resume.pdf)
      }));
    } else {
      // If no file selected (e.g., cleared), reset values
      setProfileData(prev => ({
        ...prev,
        resume: null,
        resume_name: savedResume.filename,
      }));
    }
  };

  const handleRemoveSkill = index => {
    const updatedSkills = [...sectionData.skills];
    updatedSkills.splice(index, 1);
    setSectionData({ ...sectionData, skills: updatedSkills });
  };

  const handleAddCertification = () => {
    setSectionDataSnapshot(JSON.parse(JSON.stringify(sectionData)));
    setCertificateSelectedIndex(sectionData?.certifications?.length);
    setSectionData(prev => ({
      ...prev,
      certifications: [
        ...prev.certifications,
        {
          expiryDate: '',
          issueDate: '',
          issuer: '',
          name: '',
          isNew: true,
        },
      ],
    }));

    setFormMode('certification');
    setActiveTab('form');
  };

  const handleEditCertification = (value, index) => {
    setSectionDataSnapshot(JSON.parse(JSON.stringify(sectionData)));
    setCertificateSelectedIndex(index);

    setFormMode('certification');
    setActiveTab('form');
    setCertificationForm(sectionData.certifications[index]);
    setEditingCertIndex(index);
  };

  const handleRemoveCertification = async index => {
    const updatedList = (sectionData.certifications || []).filter((_, i) => i !== index);

    const newSectionData = {
      ...sectionData,
      certifications: updatedList,
    };

    setSectionData(newSectionData);
    setIsConfirmDeleteCertificateOpen(false);
    await handleSave(true, newSectionData);
  };

  const transformEducationFromAPI = apiEducationList => {
    return apiEducationList.map(edu => ({
      school: edu.schoolName || '',
      degree: edu.degreeType || '',
      gpa: edu.gpa || '',
      major: edu.major || '',
      startDate: edu.startDate || '',
      endDate: edu.endDate || '',
      pursuing: !edu.endDate, // if no endDate, assume currently pursuing
    }));
  };

  // Converts bullet point array → HTML string
  const bulletPointsToHtml = points => {
    if (!Array.isArray(points)) return '<ul><li></li></ul>';
    const escapeHtml = value =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    return `<ul>${points.map(p => `<li>${escapeHtml(p)}</li>`).join('')}</ul>`;
  };

  // Converts HTML string → bullet point array
  const htmlToBulletPoints = html => {
    const temp = document.createElement('div');
    temp.innerHTML = html;

    const getTextWithLineBreaks = node => {
      if (!node) return '';
      if (node.nodeType === Node.TEXT_NODE) return node.textContent || '';
      if (node.nodeName === 'BR') return '\n';

      return Array.from(node.childNodes || [])
        .map(child => getTextWithLineBreaks(child))
        .join('');
    };

    const textToPoints = text =>
      String(text || '')
        .split(/\r?\n/)
        .map(line => line.replace(/^[\s•*–-]+/, '').trim())
        .filter(Boolean);

    const points = [];

    Array.from(temp.children).forEach(child => {
      if (child.matches('ul, ol')) {
        child.querySelectorAll('li').forEach(li => {
          points.push(...textToPoints(getTextWithLineBreaks(li)));
        });
        return;
      }

      if (child.matches('li, p, div')) {
        points.push(...textToPoints(getTextWithLineBreaks(child)));
      }
    });

    if (points.length > 0) return points;
    return textToPoints(getTextWithLineBreaks(temp));
  };

  function isValidPassword(password) {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{6,}$/;
    return regex.test(password);
  }
  const handleDeactivateAccount = () => {
    if (userRole === 'student_registered') {
      setOpenErrorModel(true);
      setErrorMessage('Please contact your school to deactivate your account.');
      return;
    } else {
      setIsConfirmOpen(true);
    }
  };
  const handleConfirm = async () => {
    setLoader(true);
    try {
      const data = await deactivate_seeker();
      if (!data?.code?.includes('ERR')) {
        localStorage.removeItem('login');

        // Clear cookies (if any)
        document.cookie = 'session=; Max-Age=0; path=/';

        localStorage.clear();
        window.location.href = '/login';
      } else {
        setErrorMessage(data?.message || 'Failed to deactivate account.');
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('An error occurred. Please try again.');
    } finally {
      setLoader(false);
    }
  };

  const handleConfirmCancelSubscription = async () => {
    setIsCancelSubOpen(false);
    setLoader(true);
    try {
      const response = await cancel_subscription();
      if (response && !response.code?.includes('ERR')) {
        setSuccessMessage('Subscription canceled successfully!');
        setIsSuccessOpen(true);
        fetchBillingStatus(); // Re-fetch the billing status to update the UI
      } else {
        setErrorMessage(response?.message || 'Failed to cancel subscription. Please try again.');
        setOpenErrorModel(true);
      }
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      setErrorMessage('An error occurred while cancelling your subscription.');
      setOpenErrorModel(true);
    } finally {
      setLoader(false);
    }
  };
  const isJobsActive = location.pathname === '/' || location.pathname === '/student-dashboard' || location.pathname === '/seeker-dashboard';
  const [menuOpen, setMenuOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [jobAlertsEnabled, setJobAlertsEnabled] = useState(false);
  const isSSOUser = isGoogleSSOUser(authDetails);
  const [settingsView, setSettingsView] = useState(isSSOUser ? 'jobAlerts' : 'changePassword');
  useEffect(() => {
    if (isSSOUser && settingsView === 'changePassword') {
      setSettingsView('jobAlerts');
    }
  }, [isSSOUser, settingsView]);
  const handleReplayDashboardTour = () => {
    const tourUserId = authDetails?.student?.id || authDetails?.seeker?.id || 'guest';
    localStorage.removeItem('seekjobs-dashboard-tour-seen');
    localStorage.removeItem(`seekjobs-dashboard-tour-seen-${tourUserId}`);
    localStorage.setItem('seekjobs-dashboard-tour-replay-request', 'true');
    localStorage.setItem('seekjobs-dashboard-tour-replay-recommended', 'true');
    closePopup();

    if (!isJobsActive) {
      navigate(userRole === 'student_registered' ? '/student-dashboard' : '/seeker-dashboard');
    }

    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent('seekjobs:replay-dashboard-tour', { detail: { recommended: true } }));
    }, 250);
  };
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
      key={value}
      type="text"
      className="w-full p-2 border border-gray-300 rounded cursor-pointer bg-white"
      value={value}
      onClick={onClick} // opens calendar
      ref={ref}
      placeholder="MM/YYYY"
      readOnly // blocks typing
    />
  ));

  const renderSubscriptionContent = () => {
    const preSelectedPlan = location.state?.preSelectedPlan;

    if (!billingStatus) {
      return (
        <div>
          <h4 className="mb-4">Manage Subscriptions</h4>
          <p>Loading subscription details...</p>
        </div>
      );
    }

    const { plan, subscription, flags } = billingStatus;
    const isFreeTier = plan.tier === 'FREE';
    // Correctly check for a boolean `true` from the API, not a string 'true'.

    const isPaidAndActive = !isFreeTier && (subscription?.status === 'active' || subscription?.status === 'trialing'); // This is now the single source of truth

    return (
      <>
        <h4 className="mb-4">Manage Subscriptions</h4>

        {/* Current Plan Display - Only shown for paid or transitional plans */}
        {!isFreeTier && (
          <div className="subscription-card current-plan">
            <div>
              <h5 className="plan-title">Current Plan</h5>
              <p className="plan-name">
                {plan.tier} Plan ({plan.period === 'annual' ? 'Annually' : plan.period.charAt(0).toUpperCase() + plan.period.slice(1)})
              </p>
              {!isPaidAndActive && plan.payment_status === 'succeeded' && (
                <p className="plan-renewal-info text-info">
                  Your payment was successful but the subscription is still activating. Please check back shortly or contact support.
                </p>
              )}
              {!isPaidAndActive && plan.payment_status !== 'succeeded' && (
                <>
                  <p className="plan-renewal-info text-warning">Your payment is incomplete.</p>
                  <button
                    className="btn btn-warning btn-sm mt-2"
                    onClick={handleCompletePayment} // This function will now get the right secret
                    disabled={!subscription.invoice_client_secret} // Check for the secret on the subscription object
                  >
                    Complete Payment
                  </button>
                </>
              )}

              {isPaidAndActive && !subscription.cancel_at_period_end && (
                <>
                  {subscription.next_payment?.date && (
                    <p className="plan-renewal-info">
                      Next payment of {subscription.next_payment.amount_display} on{' '}
                      {new Date(subscription.next_payment.date).toLocaleDateString()}
                    </p>
                  )}
                  {subscription.payment_method?.last4 && (
                    <p className="plan-renewal-info text-muted" style={{ fontSize: '0.8rem' }}>
                      Using {subscription.payment_method.brand} ending in {subscription.payment_method.last4}
                    </p>
                  )}
                  {isPaidAndActive && subscription.payment_method?.last4 && !subscription.cancel_at_period_end && (
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault();
                        handleChangePaymentMethod();
                      }}
                      className="d-block mt-1"
                      style={{ fontSize: '0.8rem' }}
                    >
                      Change Payment Method
                    </a>
                  )}
                </>
              )}

              {isPaidAndActive && subscription.cancel_at_period_end && (
                <p className="plan-renewal-info text-warning">
                  Expires on {new Date(subscription.current_period_end || plan.window.end).toLocaleDateString()}
                </p>
              )}
            </div>
            {!isPaidAndActive && plan.payment_status === 'succeeded' ? (
              <button className="btn btn-warning btn-sm" disabled style={{ display: 'inline-flex', alignItems: 'center' }}>
                <i className="fa-solid fa-hourglass-half me-1"></i>
                Activating...
              </button>
            ) : (
              <button
                className={`btn ${isPaidAndActive ? 'btn-success' : 'btn-secondary'} btn-sm`}
                disabled
                style={{ display: 'inline-flex', alignItems: 'center' }}
              >
                <i className="fa-solid fa-check me-1"></i>
                {isPaidAndActive ? 'Current' : 'Inactive'}
              </button>
            )}
          </div>
        )}

        {/* Explicitly show FREE plan if it's the current tier */}
        {isFreeTier && (
          <div className="subscription-card current-plan">
            <div>
              <h5 className="plan-title">Current Plan</h5>
              <p className="plan-name">FREE Plan</p>
            </div>
            <button className="btn btn-success btn-sm" disabled style={{ display: 'inline-flex', alignItems: 'center' }}>
              <i className="fa-solid fa-check me-1"></i>
              Current
            </button>
          </div>
        )}

        {/* Upgrade to PREMIUM */}
        {plan.tier !== 'PREMIUM' && (
          <div className={`subscription-card ${preSelectedPlan === 'premium' ? 'highlight' : ''}`}>
            <div>
              <h5 className="plan-title">Premium Plan</h5>
              <p className="plan-name">Maximize your job hunt with expanded daily access to resumes, cover letters and insider outreach.</p>
            </div>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate('/subscription', { state: { preSelectedPlan: 'premium' } })}
              data-bs-dismiss="offcanvas"
            >
              {isFreeTier ? 'Upgrade' : 'Change Plan'}
            </button>
          </div>
        )}

        {/* Upgrade to ELITE */}
        {plan.tier !== 'ELITE' && (
          <div className={`subscription-card ${preSelectedPlan === 'elite' ? 'highlight' : ''}`}>
            <div>
              <h5 className="plan-title">Elite Plan</h5>
              <p className="plan-name">Unlock unlimited access to all features with SeekJobs Elite.</p>
            </div>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate('/subscription', { state: { preSelectedPlan: 'elite' } })}
              data-bs-dismiss="offcanvas"
            >
              {isFreeTier ? 'Upgrade' : 'Change Plan'}
            </button>
          </div>
        )}

        {/* Support and Cancellation Links */}
        <div className="support-links">
          <p>
            Not seeing your updated subscription? <a href="mailto:support@seekjobs.ai">Contact Support</a>
          </p>
          {isPaidAndActive && !subscription.cancel_at_period_end && (
            <a
              href="#"
              className="text-danger"
              onClick={e => {
                e.preventDefault();
                setIsCancelSubOpen(true);
              }}
            >
              Cancel Subscription?
            </a>
          )}
          {isPaidAndActive && subscription.cancel_at_period_end && (
            <p className="text-muted">Your subscription is set to cancel and will not auto-renew.</p>
          )}
        </div>
      </>
    );
  };

  const handleToggleJobAlerts = async () => {
    const originalState = jobAlertsEnabled;
    const newState = !originalState;

    // Optimistically update the UI
    setJobAlertsEnabled(newState);

    try {
      const response = await joblead_subscription({ subscribed: newState });

      if (response.code?.includes('ERR')) {
        // If API fails, revert the state and show an error
        setJobAlertsEnabled(originalState);
        setErrorMessage(response.message || 'Failed to update preference.');
        setOpenErrorModel(true);
      }
    } catch (error) {
      setJobAlertsEnabled(originalState);
      setErrorMessage('An error occurred. Please try again.');
      setOpenErrorModel(true);
    }
  };

  const handleCompletePayment = async () => {
    // Re-fetch billing status to get the latest invoice secret
    await fetchBillingStatus();
    if (billingStatus?.subscription?.invoice_client_secret) {
      setClientSecret(billingStatus.subscription.invoice_client_secret);
      setPaymentMode('payment'); // It's always a payment for an incomplete invoice
      setSelectedPlanForPayment({
        // Create a temporary plan object for the offcanvas
        name: billingStatus.plan.tier,
        price: billingStatus.subscription.amount_due / 100, // Use amount_due from subscription
        cycle: billingStatus.plan.period,
      });
      setOffcanvasOpen(true);
    } else {
      setErrorMessage('Could not retrieve payment details. Please try changing your plan again or contact support.');
      setOpenErrorModel(true);
    }
  };

  const handleChangePaymentMethod = async () => {
    setLoader(true);
    try {
      const response = await create_setup_intent_for_update();
      if (response?.clientSecret) {
        setClientSecret(response.clientSecret);
        setPaymentMode('setup');
        setSelectedPlanForPayment({
          name: 'Update Payment Method',
          price: 0, // No immediate charge
          cycle: '',
        });
        setOffcanvasOpen(true);
      } else {
        setErrorMessage(response?.message || 'Could not retrieve payment details. Please try again.');
        setOpenErrorModel(true);
      }
    } catch (error) {
      setErrorMessage('An error occurred while preparing to update your payment method.');
      setOpenErrorModel(true);
    } finally {
      setLoader(false);
    }
  };
  const stripePromise = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY) : null;

  const fetchBillingStatus = async () => {
    try {
      const data = await get_billing_status();
      if (data && !data.code?.includes('ERR')) {
        setBillingStatus(data);
      } else {
        setBillingStatus(null); // Reset on error
      }
    } catch (error) {
      console.error('Error fetching billing status:', error);
      setBillingStatus(null);
    }
  };

  const handleCloseOffcanvas = () => {
    setOffcanvasOpen(false);
    setClientSecret(''); // Clear the secret when closing
    setPaymentMode('payment'); // Reset to default mode
    fetchBillingStatus(); // Re-fetch billing status to update UI
  };

  const options = {
    // For 'payment' mode, only clientSecret is needed.
    clientSecret,
    appearance: { theme: 'stripe' },
  };
  return (
    <>
      {/* For mobile desktop */}

      <div className="mobile-only">
        <div className="mobile-header-wrapper d-lg-none">
          <div className="mobile-header">
            <div
              className="mobile-left"
              onClick={() => {
                setDrawerOpen(true);
                setMenuOpen(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="tw-w-6 tw-h-6 tw-text-black"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </div>

            <div className="mobile-logo ">
              <a href="/">
                <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="logo" />
              </a>
            </div>
            <header className="page-header row" style={{ zIndex: '999' }}>
              {showHeaderSearch && (
                <div style={{ paddingLeft: 0 }} className="header-left flex-grow-1">
                  <div style={{ width: '100%' }} className="form-group-header d-lg-none">
                    <div className="Typeahead Typeahead--twitterUsers">
                      <div className="u-posRelative d-flex align-items-center">
                        <input
                          className="demo-input py-0 Typeahead-input form-control-plaintext w-100 custom-placeholder"
                          type="text"
                          placeholder={searchPlaceholder}
                          name="q"
                          value={activeSearchTerm}
                          aria-busy={!isStudentSearchRole && isSearchProcessing}
                          autoComplete="off"
                          onChange={e => {
                            if (isStudentSearchRole) {
                              setSearchTerm(e.target.value);
                            } else {
                              handlesearchChangeParam(e.target.value);
                            }
                          }}
                          onKeyDown={handleKeyDown}
                        />

                        {/* Search Icon Click */}
                        <i
                          className={searchIconClass}
                          onClick={() => {
                            if (!isSearchProcessing) {
                              triggerSearchByRole(activeSearchTerm);
                            }
                          }}
                        ></i>
                        {/* Show Dropdown only for student_registered */}
                        {userRole !== 'student_registered' && showSearchDropdown && (
                          <ul
                            ref={searchDropDownRef}
                            className="dropdown-menu show"
                            style={{
                              maxHeight: '500px',
                              overflowY: 'auto',
                              top: '27px',
                              left: '-19px',
                              width: '390px',
                            }}
                          >
                            {SearchResult.length === 0 ? (
                              <li className="dropdown-item text-muted font-14 py-2">No students or recent job matches found.</li>
                            ) : (
                              <>
                                {(() => {
                                  const students = SearchResult.filter(item => item.type === 'student');
                                  const jobs = SearchResult.filter(item => item.type === 'job');
                                  return (
                                    <>
                                      {students.length > 0 && (
                                        <>
                                          <h6 className="dropdown-header">Students</h6>
                                          {students.map(item => (
                                            <li
                                              key={item.student_id}
                                              className="dropdown-item cursor-pointer"
                                              onClick={() => {
                                                navigate('/students_details', {
                                                  state: {
                                                    student_id: item.student_id,
                                                  },
                                                });
                                                setShowSearchDropdown(false);
                                              }}
                                            >
                                              <div className="d-flex align-items-center">
                                                <img
                                                  src={item.thumbnail}
                                                  alt={item.name}
                                                  style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                    marginRight: '10px',
                                                  }}
                                                />
                                                <div>
                                                  <div>{item.name}</div>
                                                  <small className="text-muted">{item.email}</small>
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                        </>
                                      )}
                                      {students.length > 0 && jobs.length > 0 && <hr className="my-2" />}
                                      {jobs.length > 0 && (
                                        <>
                                          <h6 className="dropdown-header">Jobs</h6>
                                          {jobs.map(item => (
                                            <li
                                              key={item.job_id}
                                              className="dropdown-item cursor-pointer"
                                              onClick={() => {
                                                navigate('/job', {
                                                  state: { jobTitle: activeSearchTerm },
                                                });
                                                setShowSearchDropdown(false);
                                              }}
                                            >
                                              <div className="d-flex align-items-center">
                                                <img
                                                  src={item.thumbnail}
                                                  alt={item.title}
                                                  style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '5px',
                                                    marginRight: '10px',
                                                  }}
                                                />
                                                <div>
                                                  <div>{item.title}</div>
                                                  <small className="text-muted">{item.company}</small>
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                        </>
                                      )}
                                    </>
                                  );
                                })()}
                              </>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </header>
            <div
              className="mobile-profile"
              onClick={() => {
                setDrawerOpen(true);
                setMenuOpen(true);
              }}
              ref={dropdownRefMobile}
            >
              <img src={`${avatar}?t=${Date.now()}`} alt="profile" />
            </div>
          </div>

          {drawerOpen && (
            <div
              className="drawer-backdrop"
              onClick={() => {
                setDrawerOpen(false);
                setMenuOpen(false);
              }}
            ></div>
          )}

          <div className={`mobile-drawer ${drawerOpen ? 'open' : ''}`}>
            <div className="drawer-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              {/* Left: Logo + Name */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <img
                  src={`${avatar}?t=${Date.now()}`} // fallback image
                  alt="User Logo"
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                  }}
                />
                <h5 style={{ margin: 0 }}>{displayName}</h5>
              </div>

              {/* Right: Close Button */}
              <span
                onClick={() => {
                  setDrawerOpen(false);
                  setMenuOpen(false);
                }}
                style={{
                  fontSize: '24px',
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
              >
                &times;
              </span>
            </div>

            <ul className="drawer-nav">
              {/* Common Menu Items for all roles */}
              <li>
                <NavLink
                  onClick={() => {
                    // setActiveTab('profile'); // This is handled by the useEffect
                    openPopup('profile');
                    setDrawerOpen(false);
                    setMenuOpen(false);
                  }}
                  type="button"
                  className="text-primary font-600 padding-15"
                  aria-controls="staticBackdrop"
                  style={{ textAlign: 'left' }}
                >
                  Profile
                </NavLink>
              </li>

              {(userRole === 'student_registered' || userRole === 'seeker') && (
                <li>
                  <NavLink
                    className="text-primary font-600 padding-15"
                    style={{ textAlign: 'left' }}
                    onClick={() => {
                      setSettingsView(isSSOUser ? 'jobAlerts' : 'changePassword'); // Default to a view both roles can see
                      openPopup('settings');
                      setDrawerOpen(false);
                      setMenuOpen(false);
                    }}
                  >
                    Settings
                  </NavLink>
                </li>
              )}

              {/* Role-specific Menu Items */}
              {userRole === 'organization' && (
                <>
                  <li>
                    <NavLink
                      to="/dashboard"
                      className={({ isActive }) =>
                        isActive || location.pathname === '/'
                          ? 'btn btn-sm btn-primary set-bgbtn nav active font-600'
                          : 'text-primary font-600 padding-15'
                      }
                      style={{ textAlign: 'left' }}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to="/students"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Students
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to="/job"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Jobs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to="/employment"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Employment
                    </NavLink>
                  </li>
                  {canAccessEvents && (
                    <li>
                      <NavLink
                        style={{ textAlign: 'left' }}
                        to="/events"
                        className={isEventsActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'}
                        onClick={() => setDrawerOpen(false)}
                      >
                        Events
                      </NavLink>
                    </li>
                  )}
                </>
              )}

              {userRole === 'employer' && (
                <>
                  <li>
                    <NavLink
                      to="/employer/dashboard"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      style={{ textAlign: 'left' }}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/employer/partnerships"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      style={{ textAlign: 'left' }}
                      onClick={() => setDrawerOpen(false)}
                    >
                      Universities
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to="/employer/candidates"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Candidates
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to="/employer/jobs"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Jobs
                    </NavLink>
                  </li>
                </>
              )}

              {(userRole === 'student_registered' || userRole === 'seeker') && (
                <>
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to={`/${userRole === 'seeker' ? 'seeker-dashboard' : 'student-dashboard'}`}
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Jobs
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to={AUTOFILL_PAGE_PATH}
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Autofill Extension<span className="af-badge af-nav-badge">New</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      style={{ textAlign: 'left' }}
                      to="/insights"
                      className={({ isActive }) =>
                        isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                      }
                      onClick={() => setDrawerOpen(false)}
                    >
                      Insights
                    </NavLink>
                  </li>
                  {userRole === 'student_registered' && (
                    <li>
                      <NavLink
                        style={{ textAlign: 'left' }}
                        to="/report-employment"
                        className={({ isActive }) =>
                          isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                        }
                        onClick={() => setDrawerOpen(false)}
                      >
                        Report Employment
                      </NavLink>
                    </li>
                  )}
                  {canAccessEvents && (
                    <li>
                      <NavLink
                        style={{ textAlign: 'left' }}
                        to="/events"
                        className={isEventsActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'}
                        onClick={() => setDrawerOpen(false)}
                      >
                        Events
                      </NavLink>
                    </li>
                  )}
                  {userRole === 'seeker' && (
                    <li>
                      <NavLink
                        style={{ textAlign: 'left' }}
                        to="/subscription"
                        className={({ isActive }) =>
                          isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600 padding-15'
                        }
                        onClick={() => setDrawerOpen(false)}
                      >
                        Upgrade Your Plan
                      </NavLink>
                    </li>
                  )}
                </>
              )}

              {/* Logout */}
              <li>
                <button className="dropdown-item text-danger" onClick={handleLogout}>
                  <i className="fa-solid fa-right-from-bracket font-12"></i> Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="desktop-only">
        <header style={{ zIndex: 10, padding: '0 60px' }} className="page-header row">
          {/* For desktop Desktop */}
          <div
            className="header-container"
            style={{
              padding: '0 0px',
              width: '100%',
              maxWidth: '1440px',
              margin: '0 auto',
            }}
          >
            <div className="page-main-header d-flex align-items-center justify-content-between">
              {/* Logo */}
              <div className="logo-wrapper d-flex align-items-center">
                <a href="/">
                  <img className="light-logo img-fluid" src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="logo" />
                </a>
              </div>

              {/* Search */}
              {showHeaderSearch && (
                <div className="header-left flex-grow-1 px-3">
                  <div className="form-group-header">
                    <div className="Typeahead Typeahead--twitterUsers">
                      <div className="u-posRelative d-flex align-items-center">
                        <input
                          className="demo-input py-0 Typeahead-input form-control-plaintext w-100 custom-placeholder"
                          type="text"
                          placeholder={searchPlaceholder}
                          name="q"
                          value={activeSearchTerm}
                          aria-busy={!isStudentSearchRole && isSearchProcessing}
                          autoComplete="off"
                          onChange={e => {
                            if (isStudentSearchRole) {
                              setSearchTerm(e.target.value);
                            } else {
                              handlesearchChangeParam(e.target.value);
                            }
                          }}
                          onKeyDown={handleKeyDown}
                        />

                        <i
                          className={searchIconClass}
                          onClick={() => {
                            if (!isSearchProcessing) {
                              triggerSearchByRole(activeSearchTerm);
                            }
                          }}
                        ></i>
                        {/* Show Dropdown only for student_registered */}
                        {userRole !== 'student_registered' && showSearchDropdown && (
                          <ul
                            ref={searchDropDownRef}
                            className="dropdown-menu show"
                            style={{
                              maxHeight: '500px',
                              overflowY: 'auto',
                              top: '27px',
                              left: '-19px',
                              width: '390px',
                            }}
                          >
                            {SearchResult.length === 0 ? (
                              <li className="dropdown-item text-muted font-14 py-2">No students or recent job matches found.</li>
                            ) : (
                              <>
                                {(() => {
                                  const students = SearchResult.filter(item => item.type === 'student');
                                  const jobs = SearchResult.filter(item => item.type === 'job');

                                  return (
                                    <>
                                      {students.length > 0 && (
                                        <>
                                          <h6 className="dropdown-header">Students</h6>
                                          {/* Search Icon Click */}
                                          {students.map(item => (
                                            <li
                                              key={item.student_id}
                                              className="dropdown-item cursor-pointer"
                                              onClick={() => {
                                                navigate('/students_details', {
                                                  state: {
                                                    student_id: item.student_id,
                                                  },
                                                });
                                                setShowSearchDropdown(false);
                                              }}
                                            >
                                              <div className="d-flex align-items-center">
                                                <img
                                                  src={item.thumbnail}
                                                  alt={item.name}
                                                  style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                    marginRight: '10px',
                                                  }}
                                                />
                                                <div>
                                                  <div>{item.name}</div>
                                                  <small className="text-muted">{item.email}</small>
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                        </>
                                      )}
                                      {students.length > 0 && jobs.length > 0 && <hr className="my-2" />}
                                      {jobs.length > 0 && (
                                        <>
                                          <h6 className="dropdown-header">Jobs</h6>
                                          {jobs.map(item => (
                                            <li
                                              key={item.job_id}
                                              className="dropdown-item cursor-pointer"
                                              onClick={() => {
                                                navigate('/job', {
                                                  state: { jobTitle: activeSearchTerm },
                                                });
                                                setShowSearchDropdown(false);
                                              }}
                                            >
                                              <div className="d-flex align-items-center">
                                                <img
                                                  src={item.thumbnail}
                                                  alt={item.title}
                                                  style={{
                                                    width: '40px',
                                                    height: '40px',
                                                    borderRadius: '5px',
                                                    marginRight: '10px',
                                                  }}
                                                />
                                                <div>
                                                  <div>{item.title}</div>
                                                  <small className="text-muted">{item.company}</small>
                                                </div>
                                              </div>
                                            </li>
                                          ))}
                                        </>
                                      )}
                                    </>
                                  );
                                })()}
                              </>
                            )}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Right navigation */}
              <div className="nav-right">
                <ul className="header-right d-flex align-items-center m-0 nav-role-items">
                  {userRole === 'organization' && (
                    <>
                      <li className="me-3">
                        <NavLink
                          to="/dashboard"
                          className={({ isActive }) =>
                            isActive || location.pathname === '/'
                              ? 'btn btn-sm btn-primary set-bgbtn nav active font-600'
                              : 'text-primary font-600'
                          }
                        >
                          Home
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/students"
                          className={() =>
                            isStudentsActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Students
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/job"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Jobs
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/employment"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Employment
                        </NavLink>
                      </li>
                      {canAccessEvents && (
                        <li className="me-3">
                          <NavLink to="/events" className={isEventsActive ? "btn btn-sm btn-primary nav set-bgbtn active font-600" : "text-primary font-600"}>Events</NavLink>
                        </li>
                      )}
                    </>
                  )}

                  {userRole === 'employer' && (
                    <>
                      <li className="me-3">
                        <NavLink
                          to="/employer/dashboard"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600'
                          }
                        >
                          Home
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/employer/partnerships"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary set-bgbtn nav active font-600' : 'text-primary font-600'
                          }
                        >
                          Universities
                        </NavLink>
                      </li>
                      {/* <li className="me-3">
                        <NavLink
                          to="/employer/candidates"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Candidates
                        </NavLink>
                      </li> */}
                      <li className="me-3">
                        <NavLink
                          to="/employer/jobs"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Jobs
                        </NavLink>
                      </li>
                    </>
                  )}

                  {userRole === 'student_registered' && (
                    <>
                      <li className="me-3">
                        <NavLink
                          to="/student-dashboard"
                          className={({ isActive }) =>
                            isActive || isJobsActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Jobs
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to={AUTOFILL_PAGE_PATH}
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Autofill Extension<span className="af-badge af-nav-badge">New</span>
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/insights"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Insights
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/report-employment"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Report Employment
                        </NavLink>
                      </li>
                  {canAccessEvents && (
                    <li className="me-3">
                      <NavLink to="/events" className={isEventsActive ? "btn btn-sm btn-primary nav set-bgbtn active font-600" : "text-primary font-600"}>Events</NavLink>
                    </li>
                  )}
                    </>
                  )}

                  {/* Add condition for seeker if needed */}
                  {userRole === 'seeker' && (
                    <>
                      <li className="me-3">
                        <NavLink
                          to="/seeker-dashboard"
                          className={({ isActive }) =>
                            isActive || isJobsActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Jobs
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to={AUTOFILL_PAGE_PATH}
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Autofill Extension<span className="af-badge af-nav-badge">New</span>
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/insights"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Insights
                        </NavLink>
                      </li>
                      <li className="me-3">
                        <NavLink
                          to="/subscription"
                          className={({ isActive }) =>
                            isActive ? 'btn btn-sm btn-primary nav set-bgbtn active font-600' : 'text-primary font-600'
                          }
                        >
                          Upgrade Your Plan
                        </NavLink>
                      </li>
                    </>
                  )}

                  {/* Profile dropdown */}
                  <li
                    className="profile-nav custom-dropdown position-relative"
                    onClick={() => {
                      window.dispatchEvent(new Event('seekjobs:close-chatbot'));
                      setShowDropdown(prev => !prev);
                    }}
                    ref={dropdownRef}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="user-wrap d-flex align-items-center">
                      <div className="user-img">
                        <img src={`${avatar}?t=${Date.now()}`} alt="user" />
                      </div>
                      <div className="user-content ms-2">
                        <h6 className="mb-0 main-uni">{displayName}</h6>
                      </div>
                    </div>

                    {showDropdown && (
                      <ul
                        className="dropdown-menu show p-2 shadow"
                        onClick={e => e.stopPropagation()}
                        style={{
                          position: 'absolute',
                          top: '100%',
                          right: 0,
                          minWidth: '160px',
                          zIndex: 9999,
                        }}
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              setShowDropdown(false);
                              // setActiveTab('profile'); // This is handled by the useEffect
                              openPopup('profile');
                            }}
                            type="button"
                            aria-controls="staticBackdrop"
                          >
                            <i className="fa-solid fa-user font-12"></i> Edit Profile
                          </a>
                          {/* <a
                          className="dropdown-item"
                          {...(userRole === "student_registered" && {
                            "data-bs-toggle": "offcanvas",
                            "data-bs-target": "#editProfileCanvas",
                          })}
                          onClick={() => {
                            setTab("profile");
                            setShowDropdown(false);
                            openPopup("profile");
                          }}
                        >
                          <i className="fa-solid fa-user font-12"></i> Edit
                          Profile
                        </a> */}
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              setShowDropdown(false);
                              setSettingsView(isSSOUser ? 'jobAlerts' : 'changePassword');
                              openPopup('settings');
                            }}
                          >
                            <i className="fa-solid fa-gear font-12"></i> Settings
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              window.open('/privacy-policy', '_blank');
                            }}
                          >
                            <i className="fa-solid fa-shield-halved font-12"></i> View Privacy Policy
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              window.open('/terms-of-service', '_blank');
                            }}
                          >
                            <i className="fa-solid  fa-file-text font-12"></i> View Terms of Service
                          </a>
                        </li>

                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li>
                          <button className="dropdown-item text-danger" onClick={handleLogout}>
                            <i className="fa-solid fa-right-from-bracket font-12"></i> Logout
                          </button>
                        </li>
                      </ul>
                    )}
                  </li>
                </ul>
              </div>
            </div>

            {/* {userRole === "student_registered" && isPopupOpen && (
            <StudentProfileAndSettingPopUp
              isOpen={isPopupOpen}
              onClose={closePopup}
              Tab={Tab}
            />
          )} */}
          </div>
        </header>
      </div>
      {userRole === 'organization' && isPopupOpen && <ProfileAndSettingPopUp isOpen={isPopupOpen} onClose={closePopup} Tab={popupTab} />}
      {userRole === 'employer' && isPopupOpen && (
        <EmployerProfileAndSettingPopUp isOpen={isPopupOpen} onClose={closePopup} Tab={popupTab} />
      )}
      <div
        style={{
          borderRadius: '10px',
          maxWidth: '700px',
          width: '100%', // ensures it adapts to small screens
        }}
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="editProfileCanvas"
        aria-labelledby="staticBackdropLabel"
      >
        {/* <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="staticBackdropLabel">Offcanvas</h5>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div> */}
        <div class="offcanvas-body">
          <div
            className="container2"
            style={{
              flex: '1',
              // overflowY: "auto",
              maxWidth: '700px',
              // width: "700px"
            }}
          >
            {!formMode && (
              <div className="profileBtn-groupPropfile">
                <button className={`profileBtn ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
                  Profile
                </button>
                <button className={`profileBtn ${activeTab === 'section' ? 'active' : ''}`} onClick={() => handleTabClick('section')}>
                  Sections
                </button>
                {(userRole === 'student_registered' || userRole === 'seeker') && (
                  <button className={`profileBtn ${activeTab === 'application' ? 'active' : ''}`} onClick={() => handleTabClick('application')}>
                    Application Details
                  </button>
                )}
                <button className={`profileBtn ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => handleTabClick('settings')}>
                  Settings
                </button>
              </div>
            )}
            <div id="parent">
              {activeTab === 'application' && (userRole === 'student_registered' || userRole === 'seeker') && (
                <ApplicationProfileEditor key={userRole} onClose={closePopup} />
              )}
              {activeTab === 'profile' && (
                <div className="box a active" style={{ margin: '-13px' }}>
                  <div className="profile-header">
                    <div
                      style={{
                        position: 'relative',
                        display: 'inline-block',
                        marginTop: '-22px',
                      }}
                    >
                      <img
                        onClick={() => {
                          setImage(profileData.thumbnail);
                          setIsViewImage(true);
                        }}
                        src={`${profileData.thumbnail}?t=${Date.now()}`}
                        alt="Profile"
                        className="profile-img"
                        style={{
                          width: '85px',
                          height: '85px',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          marginTop: '12px',
                        }}
                      />

                      <span
                        className="profile-edit-icon"
                        onClick={() => {
                          setImage(profileData.thumbnail);
                          setIsImagePopupOpen(true);
                          setIsViewImage(false);
                        }}
                      >
                        {/* <i
                          className="fa-solid fa-pen"
                          style={{ fontSize: "12px", color: "#555" }}
                        ></i> */}
                        <img src={editIcon}></img>
                      </span>
                    </div>

                    <div className="profile-info">
                      <p style={{ fontSize: '18px', fontWeight: 600 }} className="university">
                        {profileData.fullName}
                      </p>
                      <p className="university">{profileData.major}</p>
                      <p className="university">
                        {window.innerWidth <= 400
                          ? profileData.email.length > 30
                            ? profileData.email.slice(0, 30) + '...'
                            : profileData.email
                          : profileData.email}
                      </p>
                    </div>
                  </div>
                  <div className="profile-form">
                    {[
                      { label: 'Full Name', name: 'fullName' },
                      { label: 'Email Address', name: 'email' },
                      { label: 'Phone', name: 'phone' },
                      // { label: "Program Major", name: "major" }, // Added Program Major field

                      { label: 'Location', name: 'location' },
                    ].map((field, index) => (
                      <div key={index}>
                        <div className="form-group ">
                          <label>
                            {field.label}
                            {field.label !== 'Phone' ? <span className="validation">*</span> : ''}
                          </label>
                        </div>
                        <div
                          className="form-field"
                          style={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'row',
                            gap: '10px',
                          }}
                        >
                          {field.name === 'phone' ? (
                            <>
                              {/* Country-code selector temporarily hidden; retain existing phone normalization. */}
                              <input
                                type="text"
                                name="phone"
                                value={profileData.phone}
                                maxLength={20}
                                onChange={handleProfileChange}
                                placeholder="Enter phone number"
                                style={{ padding: '8px', width: '100%' }}
                              />
                            </>
                          ) : field.name === 'location' ? (
                            <div style={{ position: 'relative', width: '100%' }}>
                              <input
                                type="text"
                                name="location"
                                placeholder="Enter location name"
                                value={profileData.location}
                                maxLength={30}
                                onBlur={handleProfileLocationBlur}
                                onKeyDown={e => {
                                  if (matchedLocations.length > 0) {
                                    if (e.key === 'ArrowDown') {
                                      e.preventDefault();
                                      setHighlightedLocationIndex(prev => (prev < matchedLocations.length - 1 ? prev + 1 : prev));
                                    } else if (e.key === 'ArrowUp') {
                                      e.preventDefault();
                                      setHighlightedLocationIndex(prev => (prev > 0 ? prev - 1 : prev));
                                    } else if (e.key === 'Enter') {
                                      e.preventDefault();
                                      if (highlightedLocationIndex >= 0 && highlightedLocationIndex < matchedLocations.length) {
                                        setProfileData(prev => ({ ...prev, location: matchedLocations[highlightedLocationIndex].label }));
                                        setMatchedLocations([]);
                                        setActiveLocationIndex(null);
                                      }
                                    }
                                  }
                                }}
                                onChange={e => {
                                  const val = e.target.value.replace(/[0-9]/g, '');
                                  handleProfileChange({ target: { name: 'location', value: val } });
                                  handleLocationSearch(val, 'mainProfile');
                                }}
                                style={{
                                  width: '100%',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '8px',
                                  height: '38px',
                                  backgroundColor: '#fff',
                                }}
                              />
                              {activeLocationIndex === 'mainProfile' && matchedLocations.length > 0 && (
                                <div
                                  className="location-dropdown shadow-sm"
                                  onMouseDown={event => event.stopPropagation()}
                                  onClick={event => event.stopPropagation()}
                                  style={{
                                    position: 'absolute',
                                    top: '100%',
                                    left: 0,
                                    right: 0,
                                    backgroundColor: '#fff',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    zIndex: 1050,
                                  }}
                                >
                                  {matchedLocations.map((loc, idx) => (
                                    <div
                                      key={idx}
                                      className="location-dropdown-item text-dark"
                                      style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #eee',
                                        backgroundColor: highlightedLocationIndex === idx ? '#f5f5f5' : 'transparent',
                                      }}
                                      onMouseDown={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setProfileData(prev => ({ ...prev, location: loc.label }));
                                        setMatchedLocations([]);
                                        setActiveLocationIndex(null);
                                      }}
                                      onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                      }}
                                      onMouseEnter={() => setHighlightedLocationIndex(idx)}
                                    >
                                      {loc.label}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ) : (
                            <input
                              type="text"
                              name={field.name}
                              placeholder={field.name === 'fullName' ? 'Enter Full Name' : 'Enter Value'}
                              value={profileData[field.name]}
                              onChange={handleProfileChange}
                              style={{
                                width: '100%',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                height: '38px',
                                backgroundColor: ['fullName', 'email', 'major'].includes(field.name) ? '#f9f9f9' : '#fff',
                              }}
                              readOnly={['fullName', 'email', 'major'].includes(field.name)}
                            />
                          )}
                        </div>
                        {requireMessage &&
                          (!String(profileData[field.name] || '').trim() && field.name !== 'phone' ? (
                            <span className="validation">{ERROR_MESSAGES}</span>
                          ) : field.name === 'phone' &&
                            profileData.phone &&
                            !isValidPhoneByCountry(profileData.phone, profileData.countryCode) ? (
                            <span className="validation">Enter a valid phone number</span>
                          ) : null)}
                        {errors[field.name] && <span className="validation">{errors[field.name]}</span>}
                      </div>
                    ))}

                    {PROFILE_LINK_FIELDS.map(field => (
                      <div key={field.name}>
                        <label htmlFor={`profile-${field.name}`}>{field.label} <span className="text-muted small">(optional)</span></label>
                        <input
                          id={`profile-${field.name}`}
                          type="text"
                          name={field.name}
                          value={profileData[field.name] || ''}
                          maxLength={2048}
                          placeholder={field.placeholder}
                          onChange={handleProfileChange}
                          className="form-control"
                          aria-invalid={Boolean(errors[field.name])}
                          aria-describedby={errors[field.name] ? `profile-${field.name}-error` : undefined}
                        />
                        {errors[field.name] && <span id={`profile-${field.name}-error`} className="validation" role="alert">{errors[field.name]}</span>}
                      </div>
                    ))}

                    {/* Resume Upload Section */}
                    <div className="col-span-2 mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">Resume</label>
                      <p style={{ color: '#dc2626', marginBottom: '8px' }}>
                        Uploading and saving a new resume will overwrite your current profile data.
                      </p>

                      <ProfileResumeUpload
                        file={profileData.resume}
                        savedFilename={savedResume.filename}
                        onChange={handleFileChange}
                      />

                      {/* {requireMessage && !profileData.resume && <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>} */}
                    </div>

                    <div className="validation text-center">{Error}</div>
                  </div>
                </div>
              )}
              {activeTab === 'section' && (
                <div
                  className="box a active section-tab "
                  style={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '100%',
                    paddingBottom: '120px', // 👈 prevent content from hiding behind button
                    margin: 0,
                    padding: 0,
                  }}
                >
                  {/* Education Section */}

                  <div className="d-flex justify-content-between align-items-center mb-3 responsive-head">
                    <h5
                      style={{
                        fontSize: '14px',
                        color: '#5E6278',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                      className="section-header mb-0"
                    >
                      Education
                    </h5>
                    <button
                      type="button"
                      className="btn btn-link p-0 button-res"
                      onClick={handleAddEducation}
                      style={{
                        fontSize: '14px',
                        color: '#235594',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                    >
                      Add New Education
                    </button>
                  </div>
                  {sectionData.education
                    ?.map((edu, index) => ({
                      ...edu,
                      originalIndex: index, // ✅ preserve the state index
                    }))
                    .slice()
                    .sort((a, b) => {
                      if (!a.endDate || a.endDate.trim() === '') return 1; // push empty to bottom
                      if (!b.endDate || b.endDate.trim() === '') return -1; // push empty to bottom
                      return new Date(b.endDate) - new Date(a.endDate); // ✅ descending
                    })
                    .map(edu => (
                      <div
                        key={edu.originalIndex}
                        className="entry-card bg-light-gray mb-2 d-flex justify-content-between"
                        style={sectionEntryCardStyle}
                      >
                        <div style={{ minWidth: 0, ...sectionEntryTextStyle }}>
                          {/* ✅ Only show if schoolName exists */}
                          {edu.schoolName && <h5 style={sectionEntryTitleStyle}>{edu.schoolName}</h5>}

                          {/* ✅ Only show degree & major if at least one exists */}
                          {(edu.degreeType || edu.major) && (
                            <p style={sectionEntryMetaStyle}>
                              {edu.degreeType}
                              {edu.degreeType && edu.major ? ' - ' : ''}
                              {edu.major}
                            </p>
                          )}

                          {/* ✅ Only show dates if at least one exists */}
                          {(edu.startDate || edu.endDate || edu.pursuing) && (
                            <p style={sectionEntryMetaStyle}>
                              {edu.startDate || ''}
                              {edu.startDate && (edu.endDate || edu.pursuing) ? ' - ' : ''}
                              {edu.endDate || (edu.pursuing ? 'Present' : '')}
                            </p>
                          )}
                        </div>

                        <button
                          onClick={() => handleEditEducation(edu, edu.originalIndex)}
                          className="btn btn-sm"
                          style={{ color: '#235594' }}
                        >
                          <img src={editIcon} alt="Edit" />
                        </button>
                      </div>
                    ))}

                  {/* Work Experience Section */}
                  <div className="d-flex justify-content-between align-items-center mb-3 mt-4 second-res">
                    <h5
                      style={{
                        fontSize: '14px',
                        color: '#5E6278',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                    >
                      Work Experience
                    </h5>
                    <button
                      type="button"
                      className="btn btn-link p-0 second-but"
                      onClick={handleAddWorkExperience}
                      style={{
                        fontSize: '14px',
                        color: '#235594',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                    >
                      Add New Work Experience
                    </button>
                  </div>
                  {sectionData.workExperience
                    ?.map((work, index) => ({
                      ...work,
                      originalIndex: index, // ✅ preserve the state index
                    }))
                    .slice()
                    .sort(compareWorkExperienceChronologically)
                    .map(work => (
                      <div key={work.originalIndex} className="entry-card bg-light-gray mb-2" style={sectionEntryCardStyle}>
                        <div className="d-flex justify-content-between align-items-start">
                          <div style={{ flex: 1 }}>
                            <div
                              className=" mb-3 d-flex justify-content-between
"
                            >
                              <div style={{ minWidth: 0, ...sectionEntryTextStyle }}>
                                {work.companyName && <h5 style={sectionEntryTitleStyle}>{work.companyName}</h5>}
                                {work.jobTitle && <p style={sectionEntryMetaStyle}>{work.jobTitle}</p>}
                                {work.location && <p style={sectionEntryMetaStyle}>{work.location}</p>}
                                {(work.startDate || work.endDate || work.currentlyWorkHere) && (
                                  <p style={sectionEntryMetaStyle}>
                                    {work.startDate || ''}
                                    {work.startDate && (work.endDate || work.currentlyWorkHere) ? ' - ' : ''}
                                    {work.currentlyWorkHere ? 'Present' : work.endDate || ''}
                                  </p>
                                )}
                              </div>
                              <div>
                                <button
                                  onClick={() => handleEditExperience(work, work.originalIndex)}
                                  className="btn btn-sm"
                                  style={{ color: '#235594' }}
                                >
                                  <img src={editIcon}></img>
                                </button>
                              </div>
                            </div>

                            {Array.isArray(work?.descriptionPoints) && work.descriptionPoints.some(point => point.trim() !== '') && (
                              <ul
                                style={{
                                  listStyleType: 'disc',
                                  paddingLeft: '1.2rem',
                                  marginBottom: 0,
                                }}
                              >
                                {work.descriptionPoints
                                  .filter(point => point.trim() !== '') // ✅ only render non-empty points
                                  .map((point, idx) => (
                                    <li key={idx} style={sectionEntryMetaStyle}>
                                      {point}
                                    </li>
                                  ))}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                  <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                    <h5
                      style={{
                        fontSize: '14px',
                        color: '#5E6278',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                    >
                      Skills
                    </h5>

                    {/* <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={handleAddSkill}
                    style={{
                      fontSize: "14px",
                      color: "#235594",
                      fontWeight: "600",
                      fontFamily: "Inter",
                      textDecoration: "none",
                    }}
                  >
                    Add New Skills
                  </button> */}
                  </div>

                  <SkillsInput sectionData={sectionData} setSectionData={setSectionData} />

                  <div className="d-flex justify-content-between align-items-center mb-3 mt-4 theard-res">
                    <h5
                      style={{
                        fontSize: '14px',
                        color: '#5E6278',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                    >
                      Certifications
                    </h5>
                    <button
                      type="button"
                      className="btn btn-link p-0 theard-but"
                      onClick={handleAddCertification}
                      style={{
                        fontSize: '14px',
                        color: '#235594',
                        fontWeight: '600',
                        fontFamily: 'Inter',
                        textDecoration: 'none',
                      }}
                    >
                      Add New Certification
                    </button>
                  </div>

                  {sectionData.certifications
                    .map((cert, index) => ({
                      ...cert,
                      originalIndex: index, // ✅ preserve the state index
                    }))
                    .slice()
                    .sort((a, b) => {
                      if (!a.expiryDate || a.expiryDate.trim() === '') return 1; // push empty to bottom
                      if (!b.expiryDate || b.expiryDate.trim() === '') return -1; // push empty to bottom
                      return new Date(b.expiryDate) - new Date(a.expiryDate); // ✅ descending
                    })
                    .map(cert => (
                      <div
                        style={sectionEntryCardStyle}
                        key={cert.originalIndex}
                        className="entry-card bg-light-gray mb-2 d-flex justify-content-between align-items-center p-2"
                      >
                        <div className="d-flex justify-content-between w-100">
                          <div style={{ minWidth: 0, ...sectionEntryTextStyle }}>
                            {cert.name && (
                              <h6 className="mb-1" style={sectionEntryTitleStyle}>
                                {cert.name}
                              </h6>
                            )}
                            {cert.issuer && (
                              <p className="mb-0" style={sectionEntryMetaStyle}>
                                {cert.issuer}
                              </p>
                            )}
                            {(cert.issueDate || cert.expiryDate) && (
                              <p className="mb-0" style={sectionEntryMetaStyle}>
                                {cert.issueDate ? cert.issueDate : ''} {cert.issueDate && cert.expiryDate ? ' - ' : ''}
                                {cert.expiryDate ? cert.expiryDate : ''}
                              </p>
                            )}
                          </div>
                          <button
                            className="btn btn-sm"
                            onClick={() => handleEditCertification(cert, cert.originalIndex)}
                            style={{ color: '#235594' }}
                          >
                            <img src={editIcon} alt="Edit" />
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              )}

              {activeTab === 'form' && (
                <div
                  className=" a active section-tab  "
                  style={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '100%',
                  }}
                >
                  {formMode === 'education' && (
                    <div className="education-form-container ">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center position-relative mb-2">
                        <button className="btn btn-sm" style={{ fontSize: '18px' }} onClick={handleDiscardAttempt}>
                          <FaArrowLeft />
                        </button>
                        <h5 className="m-0 text-center flex-grow-1" style={{ fontSize: '14px' }}>
                          Education
                        </h5>
                        <button
                          className="btn btn-sm position-absolute top-0 end-0"
                          style={{ fontSize: '18px' }}
                          onClick={handleDiscardAttempt}
                        >
                          ✕
                        </button>{' '}
                      </div>

                      {/* Dynamic Education Entries (example for 1 form item) */}
                      <div>
                        {sectionData.education
                          ?.map((education, index) => ({
                            ...education,
                            originalIndex: index,
                          }))
                          .filter(edu => edu.originalIndex === educationSelectedIndex) // ✅ exact match
                          .map(education => (
                            <div
                              key={education.originalIndex}
                              className="entry-card mb-4 position-relative"
                              style={{ backgroundColor: '#F7FBFF' }}
                            >
                              <div className="d-flex" style={{ justifyContent: 'space-between', width: '100%' }}>
                                <h6 className="fw-bold">Edit Education</h6>
                                {!education.isNew && (
                                  <button
                                    className="border-none"
                                    onClick={() => {
                                      setMessage(`Are you sure you want to delete this education record?`);

                                      setEDUoriginalIndex(education.originalIndex);
                                      setIsConfirmDeleteEduOpen(true);
                                    }}
                                    style={{
                                      color: '#235594',
                                      border: 'none',
                                      backgroundColor: 'transparent',
                                    }}
                                  >
                                    Delete
                                  </button>
                                )}
                              </div>
                              {/* ✅ School */}
                              <div className="mb-3">
                                <label>
                                  School / University <span className="text-danger text-start">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter school name"
                                  value={education.schoolName}
                                  maxLength={SECTION_TEXT_MAX_LENGTH}
                                  onChange={e => handleChange(education.originalIndex, 'schoolName', e.target.value.replace(/[0-9]/g, ''))}
                                />
                                {requireMessage && !education.schoolName && (
                                  <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>
                                )}
                              </div>

                              {/* ✅ Degree + GPA */}
                              <div className="row">
                                <div className="col">
                                  <label>
                                    Academic Qualification <span className="text-danger text-start">*</span>
                                  </label>
                                  <select
                                    className="form-select"
                                    value={education.degreeType}
                                    onChange={e => handleChange(education.originalIndex, 'degreeType', e.target.value)}
                                  >
                                    <option value="">Select</option>
                                    <option value="High School">High School</option>
                                    <option value="Diploma">Diploma</option>
                                    <option value="Associate Degree">Associate Degree</option>
                                    <option value="Bachelors Degree">Bachelors Degree</option>
                                    <option value="Masters Degree">Masters Degree</option>
                                    <option value="Phd Degree">PhD Degree</option>
                                  </select>
                                  {requireMessage && !education.degreeType && (
                                    <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>
                                  )}
                                </div>
                                <div className="col">
                                  <label>GPA</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="GPA"
                                    value={education.gpa || ''}
                                    onChange={e => {
                                      let value = e.target.value;
                                      const regex = /^(10(\.0{1,2})?|[1-9](\.\d{0,2})?)?$/;
                                      if (value === '' || regex.test(value)) {
                                        handleChange(education.originalIndex, 'gpa', value);
                                      }
                                    }}
                                  />
                                  {/* {requireMessage && !education.gpa && <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>} */}
                                </div>
                              </div>

                              {/* ✅ Field of Study */}
                              <div className="mb-3 mt-3">
                                <label>Field of Study / Major</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter field of study"
                                  value={education.major}
                                  maxLength={SECTION_TEXT_MAX_LENGTH}
                                  onChange={e => handleChange(education.originalIndex, 'major', e.target.value.replace(/[0-9]/g, ''))}
                                />
                                {/* {requireMessage && !education.major && <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>} */}
                              </div>

                              {/* ✅ Dates */}
                              <div className="row">
                                <div className="col-6">
                                  <label>Start Date</label>

                                  <CustomMonthYearPicker
                                    label="Start Date"
                                    value={education.startDate || ''}
                                    onChange={val => handleChange(education.originalIndex, 'startDate', val)}
                                    max={
                                      education.endDate
                                        ? education.endDate < currentMonth
                                          ? education.endDate
                                          : currentMonth
                                        : currentMonth
                                    } // YYYY-MM format
                                  />
                                </div>
                                <div className="col-6">
                                  <label>End Date</label>
                                  <CustomMonthYearPicker
                                    label="End Date"
                                    value={education.endDate || ''}
                                    onChange={val => handleChange(education.originalIndex, 'endDate', val)}
                                    min={education.startDate || null}
                                    disabled={education.pursuing} // YYYY-MM format
                                  />{' '}
                                </div>
                              </div>

                              {/* ✅ Checkbox */}
                              <div className="form-check mt-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`pursuing-${education.originalIndex}`}
                                  checked={education.pursuing}
                                  onChange={e => handleChange(education.originalIndex, 'pursuing', e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor={`pursuing-${education.originalIndex}`}>
                                  I’m currently pursuing
                                </label>
                              </div>
                            </div>
                          ))}
                      </div>

                      {/* Bottom Buttons */}
                    </div>
                  )}

                  {formMode === 'workExperiance' && (
                    <div className="education-form-container ">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center position-relative mb-2">
                        <button className="btn btn-sm" style={{ fontSize: '18px' }} onClick={handleDiscardAttempt}>
                          <FaArrowLeft />
                        </button>
                        <h5 className="m-0 text-center flex-grow-1" style={{ fontSize: '14px' }}>
                          Work Experience
                        </h5>
                        <button
                          className="btn btn-sm position-absolute top-0 end-0"
                          style={{ fontSize: '18px' }}
                          onClick={handleDiscardAttempt}
                        >
                          ✕
                        </button>
                      </div>

                      {/* Dynamic Education Entries (example for 1 form item) */}
                      <div>
                        {sectionData?.workExperience
                          ?.map((experience, index) => ({
                            ...experience,
                            originalIndex: index, // ✅ keep original index for safe updates
                          }))
                          .filter((_, index) => index === experienceSelectedIndex) // ✅ only render the selected one
                          .map(
                            (
                              experience, // don't reuse "index" here, rely on originalIndex
                            ) => (
                              <div
                                key={experience.originalIndex}
                                className="entry-card mb-4 position-relative"
                                style={{ backgroundColor: '#F7FBFF' }}
                              >
                                <div className="d-flex justify-content-between w-100">
                                  <h6 className="fw-bold">Edit Work Experience</h6>
                                  {!experience.isNew && (
                                    <button
                                      className="border-none"
                                      onClick={() => {
                                        setMessage(`Are you sure you want to delete this work experience?`);
                                        setWorkExpOriginalIndex(experience.originalIndex);
                                        setIsConfirmDeleteWorkOpen(true);
                                      }}
                                      style={{
                                        color: '#235594',
                                        border: 'none',
                                        backgroundColor: 'transparent',
                                      }}
                                    >
                                      Delete
                                    </button>
                                  )}
                                </div>
                                <div className="mb-3">
                                  <label>
                                    Job Title <span className="text-danger text-start">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter job title"
                                    value={experience.jobTitle}
                                    maxLength={SECTION_TEXT_MAX_LENGTH}
                                    onChange={e =>
                                      handleExperienceChange(experience.originalIndex, 'jobTitle', e.target.value.replace(/[0-9]/g, ''))
                                    }
                                  />
                                  {requireMessage && !experience.jobTitle && (
                                    <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>
                                  )}
                                </div>

                                <div className="row">
                                  <div className="col">
                                    <label>
                                      Company <span className="text-danger text-start">*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter company name"
                                      value={experience.companyName}
                                      maxLength={SECTION_TEXT_MAX_LENGTH}
                                      onChange={e =>
                                        handleExperienceChange(
                                          experience.originalIndex,
                                          'companyName',
                                          e.target.value.replace(/[0-9]/g, ''),
                                        )
                                      }
                                    />
                                    {requireMessage && !experience.companyName && (
                                      <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>
                                    )}
                                  </div>
                                  <div className="col">
                                    <label>Location</label>
                                    <div style={{ position: 'relative' }}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter location"
                                        value={experience.location}
                                        maxLength={SECTION_TEXT_MAX_LENGTH}
                                        onBlur={() => handleExperienceLocationBlur(experience.originalIndex, experience.location)}
                                        onKeyDown={e => {
                                          if (matchedLocations.length > 0) {
                                            if (e.key === 'ArrowDown') {
                                              e.preventDefault();
                                              setHighlightedLocationIndex(prev => (prev < matchedLocations.length - 1 ? prev + 1 : prev));
                                            } else if (e.key === 'ArrowUp') {
                                              e.preventDefault();
                                              setHighlightedLocationIndex(prev => (prev > 0 ? prev - 1 : prev));
                                            } else if (e.key === 'Enter') {
                                              e.preventDefault();
                                              if (highlightedLocationIndex >= 0 && highlightedLocationIndex < matchedLocations.length) {
                                                handleExperienceChange(
                                                  experience.originalIndex,
                                                  'location',
                                                  matchedLocations[highlightedLocationIndex].label,
                                                );
                                                setMatchedLocations([]);
                                                setActiveLocationIndex(null);
                                              }
                                            }
                                          }
                                        }}
                                        onChange={e => {
                                          const val = e.target.value.replace(/[0-9]/g, '');
                                          handleExperienceChange(experience.originalIndex, 'location', val);
                                          handleLocationSearch(val, experience.originalIndex);
                                        }}
                                      />
                                      {activeLocationIndex === experience.originalIndex && matchedLocations.length > 0 && (
                                        <div
                                          className="location-dropdown shadow-sm"
                                          onMouseDown={event => event.stopPropagation()}
                                          onClick={event => event.stopPropagation()}
                                          style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            backgroundColor: '#fff',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            maxHeight: '200px',
                                            overflowY: 'auto',
                                            zIndex: 1050,
                                          }}
                                        >
                                          {matchedLocations.map((loc, idx) => (
                                            <div
                                              key={idx}
                                              className="location-dropdown-item text-dark"
                                              style={{
                                                padding: '8px 12px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #eee',
                                                backgroundColor: highlightedLocationIndex === idx ? '#f5f5f5' : 'transparent',
                                              }}
                                              onMouseDown={e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleExperienceChange(experience.originalIndex, 'location', loc.label);
                                                setMatchedLocations([]);
                                                setActiveLocationIndex(null);
                                              }}
                                              onClick={e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                              }}
                                              onMouseEnter={() => setHighlightedLocationIndex(idx)}
                                            >
                                              {loc.label}
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="row" style={{ marginTop: '12px' }}>
                                  <div className="col-6">
                                    <label>Start Date</label>
                                    <CustomMonthYearPicker
                                      label="Start Date"
                                      value={experience.startDate || ''}
                                      onChange={val => handleExperienceChange(experience.originalIndex, 'startDate', val)}
                                      max={
                                        experience.endDate
                                          ? experience.endDate < currentMonth
                                            ? experience.endDate
                                            : currentMonth
                                          : currentMonth
                                      }
                                    />{' '}
                                  </div>
                                  <div className="col-6">
                                    <label>End Date</label>
                                    <CustomMonthYearPicker
                                      label="End Date"
                                      value={experience.endDate || ''}
                                      onChange={val => handleExperienceChange(experience.originalIndex, 'endDate', val)}
                                      disabled={experience.currentlyWorkHere}
                                      min={experience.startDate || null}
                                    />{' '}
                                  </div>
                                </div>

                                <div className="form-check mt-3">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`pursuing-${experience.originalIndex}`}
                                    checked={experience.currentlyWorkHere}
                                    onChange={() =>
                                      handleExperienceChange(experience.originalIndex, 'currentlyWorkHere', !experience.currentlyWorkHere)
                                    }
                                  />
                                  <label className="form-check-label" htmlFor={`pursuing-${experience.originalIndex}`}>
                                    I’m currently working here
                                  </label>
                                </div>

                                <div>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                                  <RichTextEditor
                                    html={bulletPointsToHtml(experience.descriptionPoints || [])}
                                    onChange={html => {
                                      // Convert HTML → bullet points
                                      let bulletPoints = htmlToBulletPoints(html);

                                      // ✅ Prevent bullet points starting with space
                                      bulletPoints = bulletPoints.map(point => (point.startsWith(' ') ? point.trimStart() : point));

                                      handleExperienceChange(experience.originalIndex, 'descriptionPoints', bulletPoints);
                                    }}
                                  />
                                </div>
                              </div>
                            ),
                          )}
                      </div>
                    </div>
                  )}

                  {formMode === 'certification' && (
                    <div className="education-form-container ">
                      {/* Header */}
                      <div className="d-flex justify-content-between align-items-center position-relative mb-2">
                        <button className="btn btn-sm" style={{ fontSize: '18px' }} onClick={handleDiscardAttempt}>
                          <FaArrowLeft />
                        </button>
                        <h5 className="m-0 text-center flex-grow-1" style={{ fontSize: '14px' }}>
                          Certifications
                        </h5>
                        <button
                          className="btn btn-sm position-absolute top-0 end-0"
                          style={{ fontSize: '18px' }}
                          onClick={handleDiscardAttempt}
                        >
                          ✕
                        </button>
                      </div>

                      {/* Dynamic Education Entries (example for 1 form item) */}
                      <div>
                        {sectionData?.certifications
                          ?.map((certifications, index) => ({
                            ...certifications,
                            originalIndex: index,
                          })) // attach original index
                          .filter((_, index) => index === certificateSelectedIndex) // filter by visible item index (e.g., only second one)
                          .map(value => (
                            <div
                              key={value.originalIndex}
                              className=" entry-card mb-4 position-relative"
                              style={{ backgroundColor: '#F7FBFF' }}
                            >
                              <div
                                className="d-flex "
                                style={{
                                  justifyContent: 'space-between',
                                  width: '100%',
                                }}
                              >
                                <h6 className="fw-bold">Edit Certification</h6>
                                {!value.isNew && (
                                  <button
                                    className="border-none"
                                    // onClick={() => handleRemoveCertification(index)}
                                    onClick={() => {
                                      setMessage(`Are you sure you want to delete this certification?`);
                                      setCertificateOriginalIndex(value.originalIndex);
                                      setIsConfirmDeleteCertificateOpen(true);
                                    }}
                                    style={{
                                      color: '#235594',
                                      border: 'none',
                                      backgroundColor: 'transparent',
                                    }}
                                  >
                                    Delete
                                  </button>
                                )}
                              </div>
                              <div className="mb-3">
                                <label>
                                  Certification Name <span className="text-danger text-start">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter certification name"
                                  value={value.name}
                                  maxLength={SECTION_TEXT_MAX_LENGTH}
                                  onChange={e =>
                                    handleCertificationsChange(value.originalIndex, 'name', e.target.value.replace(/[0-9]/g, ''))
                                  }
                                />
                                {requireMessage && !value.name && <span className="tw-text-red-500 text-xs">{ERROR_MESSAGES}</span>}
                              </div>

                              <div className="row">
                                <div className="col">
                                  <label>Issuing Organization</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter company name"
                                    value={value.issuer}
                                    maxLength={SECTION_TEXT_MAX_LENGTH}
                                    onChange={e =>
                                      handleCertificationsChange(value.originalIndex, 'issuer', e.target.value.replace(/[0-9]/g, ''))
                                    }
                                  />
                                </div>
                                <div className="col">
                                  <label>Credential URL</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter credential URL  "
                                    value={value.credentialURL}
                                    maxLength={SECTION_TEXT_MAX_LENGTH}
                                    onChange={e => handleCertificationsChange(value.originalIndex, 'credentialURL', e.target.value)}
                                  />
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-6">
                                  <label>Issue Date</label>
                                  <CustomMonthYearPicker
                                    label="Issue Date"
                                    value={value.issueDate || ''}
                                    onChange={val => handleCertificationsChange(value.originalIndex, 'issueDate', val)}
                                    max={
                                      value.expiryDate ? (value.expiryDate < currentMonth ? value.expiryDate : currentMonth) : currentMonth
                                    }
                                  />{' '}
                                  {/* <DatePicker
                                    selected={value.issueDate ? (value.issueDate) : null}
                                    onChange={(date) => {
                                      // format to YYYY-MM for storage
                                      const formatted = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}` : "";
                                      handleCertificationsChange(value.originalIndex, "issueDate", formatted);
                                    }}
                                    dateFormat="MM/yyyy"         // display format
                                    showMonthYearPicker          // ✅ ensures only month/year selection
                                    placeholderText="MM/YYYY"
                                    customInput={<CustomInput />} // ✅ read-only custom input
                                    className="w-full p-2 border border-gray-300 rounded"
                                    maxDate={value.expiryDate ? (value.expiryDate) : null}
                                  /> */}
                                </div>
                                <div className="col-6">
                                  <label>Expiration Date</label>
                                  <CustomMonthYearPicker
                                    label="Expiration Date"
                                    value={value.expiryDate || ''}
                                    onChange={val => handleCertificationsChange(value.originalIndex, 'expiryDate', val)}
                                    min={value.issueDate || null}
                                  />{' '}
                                  {/* <DatePicker
                                    selected={value.expiryDate ? (value.expiryDate) : null}
                                    onChange={(date) => {
                                      // format to YYYY-MM for storage
                                      const formatted = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}` : "";
                                      handleCertificationsChange(value.originalIndex, "expiryDate", formatted);
                                    }}
                                    dateFormat="MM/yyyy"         // display format
                                    showMonthYearPicker          // ✅ ensures only month/year selection
                                    placeholderText="MM/YYYY"
                                    customInput={<CustomInput />} // ✅ read-only custom input
                                    className="w-full p-2 border border-gray-300 rounded"
                                    minDate={
                                      value.issueDate ? (value.issueDate) : null
                                    }
                                  /> */}
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>

                      {/* Bottom Buttons */}
                      {/* <div className="d-flex " style={{ width: '80%', gap: '10px' }}>
                        <button
                          className="btn  "
                          style={{ color: '#235594' }}
                          onClick={() => {
                            setSectionData((prev) => ({
                              ...prev,
                              certifications: [
                                ...prev.certifications,
                                {
                                  name: null,
                                  issuer: null,
                                  location: null,
                                  issueDate: null,
                                  expiryDate: null,
                                  credentialURL: false
                                },
                              ],
                            }));
                          }}
                        >
                          Add New Certificate
                        </button>

                      </div> */}
                    </div>
                  )}
                </div>
              )}

              {activeTab === 'settings' && (
                <div className="box b active" style={{ display: 'flex', gap: '20px' }}>
                  {/* Left Navigation Panel */}
                  <div className="settings-nav" style={{ flex: '0 0 180px', borderRight: '1px solid #eee' }}>
                    <ul className="list-unstyled">
                      {!isSSOUser && (
                        <li
                          className={`settings-nav-item ${settingsView === 'changePassword' ? 'active' : ''}`}
                          onClick={() => setSettingsView('changePassword')}
                        >
                          Reset Password
                        </li>
                      )}
                      {userRole === 'seeker' && process.env.REACT_APP_PAYMENT_SUBSCRIPTION_ENABLED === 'true' && (
                        <li
                          className={`settings-nav-item ${settingsView === 'manageSubscriptions' ? 'active' : ''}`}
                          onClick={() => setSettingsView('manageSubscriptions')}
                        >
                          Manage Subscriptions
                        </li>
                      )}

                      <li
                        className={`settings-nav-item ${settingsView === 'jobAlerts' ? 'active' : ''}`}
                        onClick={() => setSettingsView('jobAlerts')}
                      >
                        Email Notification Preference
                      </li>
                      <li
                        className={`settings-nav-item ${settingsView === 'manageAccount' ? 'active' : ''}`}
                        onClick={() => setSettingsView('manageAccount')}
                      >
                        Manage My Account
                      </li>
                      <li
                        className={`settings-nav-item ${settingsView === 'help' ? 'active' : ''}`}
                        onClick={() => setSettingsView('help')}
                      >
                        Help
                      </li>
                      <li
                        className="settings-nav-item"
                        style={{ cursor: 'pointer' }}
                        onClick={() => window.open('/privacy-policy', '_blank')}
                      >
                        Privacy Policy
                      </li>
                      <li
                        className="settings-nav-item"
                        style={{ cursor: 'pointer' }}
                        onClick={() => window.open('/terms-of-service', '_blank')}
                      >
                        Terms of Service
                      </li>
                    </ul>
                  </div>

                  {/* Right Content Area */}
                  <div className="settings-content" style={{ flex: 1 }}>
                    {!isSSOUser && settingsView === 'changePassword' && (
                      <form
                        className="profile-form"
                        onSubmit={event => {
                          event.preventDefault();
                          handleUpdatePassword();
                        }}
                      >
                        <h4 className="mb-3">Reset Password</h4>
                        {[
                          { label: 'Password', name: 'password' },
                          { label: 'New Password', name: 'newPassword' },
                          { label: 'Retype New Password', name: 'retypePassword' },
                        ].map((field, index) => (
                          <div key={index} className="">
                            <div className="form-group d-flex justify-content-between align-items-center">
                              <label>{field.label}</label>
                            </div>

                            <div className="form-field position-relative">
                              <input
                                type={showPassword[field.name] ? 'text' : 'password'}
                                style={{
                                  width: '100%',
                                  border: '1px solid #ccc',
                                  borderRadius: '4px',
                                  padding: '8px',
                                  height: '38px',
                                }}
                                name={field.name}
                                autoComplete="new-password"
                                value={settingsData[field.name]}
                                onChange={handleSettingsChange}
                                placeholder={
                                  field.name === 'password'
                                    ? 'Enter Current Password'
                                    : field.name === 'newPassword'
                                      ? 'Enter New Password'
                                      : 'Retype New Password'
                                }
                              />
                              <span
                                onClick={() => toggleVisibility(field.name)}
                                style={{
                                  cursor: 'pointer',
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  fontSize: '16px',
                                  color: '#007bff',
                                }}
                              >
                                {!showPassword[field.name] ? (
                                  <i className="fa-solid fa-eye-slash"></i>
                                ) : (
                                  <i className="fa-solid fa-eye"></i>
                                )}
                              </span>
                            </div>

                            {/* Show validation error for all fields */}
                            {errors[field.name] && <div className="text-danger font-12 mt-1">{errors[field.name]}</div>}

                            {/* Show strength bar + rules only for newPassword */}
                            {field.name === 'newPassword' && settingsData.newPassword && (
                              <div style={{ marginTop: '8px' }}>
                                {/* Strength bar */}
                                <div
                                  style={{
                                    height: '5px',
                                    background: '#e9ecef',
                                    borderRadius: '4px',
                                    overflow: 'hidden',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: getStrengthWidth(passwordStrength),
                                      height: '100%',
                                      background: getStrengthColor(passwordStrength),
                                      transition: 'width 0.3s',
                                    }}
                                  ></div>
                                </div>

                                <small
                                  style={{
                                    color: getStrengthColor(passwordStrength),
                                    fontWeight: 500,
                                  }}
                                >
                                  Strength: {passwordStrength}
                                </small>

                                {/* Password rules shown only if no form error */}
                                {!errors.newPassword && (
                                  <ul className="text-danger mt-2 mb-0 ps-3" style={{ fontSize: '12px' }}>
                                    {settingsData.newPassword.length < 8 && <li>Password must be at least 8 characters long.</li>}
                                    {!/[A-Z]/.test(settingsData.newPassword) && (
                                      <li>Password must contain at least one uppercase letter.</li>
                                    )}
                                    {!/[a-z]/.test(settingsData.newPassword) && (
                                      <li>Password must contain at least one lowercase letter.</li>
                                    )}
                                    {!/\W/.test(settingsData.newPassword) && <li>Password must contain at least one special character.</li>}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>
                        ))}

                        {Error && <div className="text-danger text-center font-12 mt-1">{Error}</div>}

                        <div className="d-flex justify-content-start gap-5 mb-1" style={{ width: 'max-content' }}>
                          <button
                            type="submit"
                            className="profileBtn save small-btn"
                            style={{
                              marginTop: '5px',
                              width: 'max-content',
                              whiteSpace: 'nowrap',
                              display: 'inline-flex',
                              alignItems: 'center',
                            }}
                          >
                            <i className="fa-solid fa-circle-check me-1"></i>
                            Update Password
                          </button>
                        </div>
                      </form>
                    )}
                    {settingsView === 'manageSubscriptions' && process.env.REACT_APP_PAYMENT_SUBSCRIPTION_ENABLED === 'true' && (
                      <div className="subscription-management">{renderSubscriptionContent()}</div>
                    )}
                    {settingsView === 'jobAlerts' && (
                      <div>
                        <div className="job-alerts-preference">
                          <h4 className="mb-3">Email Notification Preference</h4>
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <label className="form-label mb-0">Job Alerts</label>
                              <p className="form-text mt-0" style={{ fontSize: '0.8rem', color: '#6c757d' }}>
                                Up to 10 job leads in my inbox everyday
                              </p>
                            </div>
                            <label className="toggle-switch">
                              <input type="checkbox" checked={jobAlertsEnabled} onChange={handleToggleJobAlerts} />
                              <span className="slider"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    {settingsView === 'manageAccount' && (
                      <div className="text-start">
                        <div className="job-alerts-preference text-start">
                          <h4 className="mb-3 text-start">Manage My Account</h4>
                          <div className="d-flex flex-column justify-content-start align-items-start text-start">
                            <div className="mb-2 text-start">
                              <label className="form-label mb-0 text-start">Deactivate Account</label>
                              <p className="form-text mt-0 text-start" style={{ fontSize: '0.8rem', color: '#6c757d' }}>
                                This will permanently delete your account and all associated data.
                              </p>
                            </div>
                            <div className="d-flex justify-content-start  gap-2 mt-2">
                              <button
                                onClick={() => {
                                  handleDeactivateAccount();
                                }}
                                type="button"
                                className="profileBtn save main-delet small-btn"
                                style={{ whiteSpace: 'nowrap', width: 'max-content', display: 'flex', alignItems: 'center' }}
                              >
                                <i className="fa-solid fa-trash me-2"></i>
                                Deactivate Account
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {settingsView === 'help' && (
                      <div className="text-start">
                        <div className="job-alerts-preference text-start">
                          <h4 className="mb-3 text-start">Help</h4>
                          <div className="d-flex flex-column justify-content-start align-items-start text-start">
                            <div className="mb-2 text-start">
                              <label className="form-label mb-0 text-start">Dashboard Tour</label>
                              <p className="form-text mt-0 text-start" style={{ fontSize: '0.8rem', color: '#6c757d' }}>
                                Replay the guided walkthrough for job listings, filters, scores, saving jobs, and applying.
                              </p>
                            </div>
                            <button
                              type="button"
                              className="profileBtn save small-btn"
                              style={{ whiteSpace: 'nowrap', width: 'max-content', display: 'flex', alignItems: 'center' }}
                              onClick={handleReplayDashboardTour}
                            >
                              <i className="fa-solid fa-circle-question me-2"></i>
                              Replay Dashboard Tour
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {activeTab === 'application' ? <div id="application-profile-footer" /> : <div style={{ padding: '10px' }}>
          <div
            className="button-group"
            style={{
              marginRight: '8rem',
              position: 'sticky',
              bottom: '0', // or top: "0" if you want it sticky at the top
              backgroundColor: '#fff', // optional: ensures the buttons have a solid background
              padding: '10px 0', // optional: for spacing
              zIndex: 100, // ensures it stays above other elements
              width: window.innerWidth <= 768 ? '100%' : formMode === 'workExperiance' ? '54%' : '48%',
            }}
          >
            {formMode === null && (
              <button
                style={{ maxWidth: '35%' }}
                type="button"
                className="profileBtn cancel"
                onClick={() => {
                  setError('');
                  closePopup();
                }}
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Close
              </button>
            )}

            {activeTab !== 'settings' && activeTab !== 'application' && (
              <button type="button" className="profileBtn save" onClick={() => handleSave()}>
                <i className="fa-solid fa-floppy-disk"></i> Save Changes
              </button>
            )}
          </div>
        </div>}
      </div>
      <SuccessModel
        isOpen={isSuccessOpen}
        title="Success!"
        message={
          successMessage ||
          (activeTab === 'profile' || activeTab === 'section' || formMode !== null
            ? 'Profile updated successfully!'
            : 'Settings updated successfully!')
        }
        messageClassName={successMessage ? 'text-center' : 'text-start'}
        buttonText="OK"
        onClose={() => {
          setFormMode(null);
          setActiveTab(activeTab);
          setIsSuccessOpen(false);
          setSuccessMessage('');
          setAddUpdateDone(true);
          setRequireMessage(false);
          setError('');
        }}
      />
      {/* <StudentProfileSuccessModal
        isOpen={isSuccessOpen}
        title="Success!"
        message={
          activeTab === "profile" || activeTab === "Sections"
            ? "Profile updated successfully!"
            : "Settings updated successfully!"
        }
        buttonText="OK"
        onClose={() => {

          setIsSuccessOpen(false);
          closePopup();
        }}
      /> */}
      {isImagePopupOpen && (
        <ImageUploadEditModal
          image={image}
          onClose={() => setIsImagePopupOpen(false)}
          isAddUpdateDone={isAddUpdateDone}
          setAddUpdateDone={setAddUpdateDone}
          Type={'Profile'}
        />
      )}
      {IsViewImage && <ViewImagePopup image={image} onClose={() => setIsViewImage(false)} />}
      {isOpenErrorModel && (
        <ErrorModel
          isOpen={isOpenErrorModel}
          title="Alert!"
          message={ErrorMessage}
          buttonText="OK"
          onClose={() => setOpenErrorModel(false)}
        />
      )}
      {isConfirmOpen && (
        <ConfirmationModal
          isOpen={isConfirmOpen}
          title="Alert!"
          message="Are you sure you want to deactivate your account?"
          confirmText={
            <>
              <i className="fas fa-trash me-2"></i>Yes, Deactivate
            </>
          }
          subMessage="You will lose all access to your current account."
          action="Delete"
          onConfirm={handleConfirm}
          onCancel={() => setIsConfirmOpen(false)}
        />
      )}

      {isCancelSubOpen && (
        <ConfirmationModal
          isOpen={isCancelSubOpen}
          title="Cancel Subscription"
          message="Are you sure you want to cancel your subscription? This action cannot be undone."
          confirmText={
            <>
              <i className="fas fa-times-circle me-2"></i>Yes, Cancel
            </>
          }
          subMessage="Your premium features will be disabled at the end of your current billing cycle."
          action="Delete"
          onConfirm={handleConfirmCancelSubscription}
          onCancel={() => setIsCancelSubOpen(false)}
        />
      )}

      {isConfirmDeleteEduOpen && (
        <ConfirmationModal
          isOpen={isConfirmDeleteEduOpen}
          title="Alert!"
          message={message}
          confirmText={
            <>
              <i className="fas fa-trash me-2"></i>Yes, Delete
            </>
          }
          subMessage=""
          action="Delete"
          onConfirm={() => handleRemoveEducation(EDUoriginalIndex)} // ✅ wrapped
          onCancel={() => setIsConfirmDeleteEduOpen(false)}
        />
      )}

      {isConfirmDeleteWorkOpen && (
        <ConfirmationModal
          isOpen={isConfirmDeleteWorkOpen}
          title="Alert!"
          message={message}
          subMessage=""
          confirmText={
            <>
              <i className="fas fa-trash me-2"></i>Yes, Delete
            </>
          }
          action="Delete"
          onConfirm={() => handleRemoveWorkExperience(workExpOriginalIndex)} // ✅ wrapped
          onCancel={() => setIsConfirmDeleteWorkOpen(false)}
        />
      )}
      {isConfirmDeleteCertificateOpen && (
        <ConfirmationModal
          isOpen={isConfirmDeleteCertificateOpen}
          title="Alert!"
          message={message}
          subMessage=""
          confirmText={
            <>
              <i className="fas fa-trash me-2"></i>Yes, Delete
            </>
          }
          action="Delete"
          onConfirm={() => handleRemoveCertification(certificateOriginalIndex)} // ✅ wrapped
          onCancel={() => setIsConfirmDeleteCertificateOpen(false)}
        />
      )}

      {isDiscardConfirmOpen && (
        <ConfirmationModal
          isOpen={isDiscardConfirmOpen}
          title="Discard Changes?"
          message="Are you sure you want to discard your unsaved changes?"
          subMessage="Any information you've entered in this form will be lost."
          confirmText="Yes, Discard"
          cancelText="Go Back"
          action="Warning"
          onConfirm={handleConfirmDiscard}
          onCancel={() => setIsDiscardConfirmOpen(false)}
        />
      )}

      {clientSecret && stripePromise && isOffcanvasOpen && (
        <Elements stripe={stripePromise} options={options} key={clientSecret}>
          <StripeOffcanvas isOpen={isOffcanvasOpen} onClose={handleCloseOffcanvas} plan={selectedPlanForPayment} mode={paymentMode} />
        </Elements>
      )}
    </>
  );
};

export default NavHeader;
